// English source strings. Every other locale mirrors these keys exactly.
const en = {
  "nav.home": "Home",
  "nav.browse": "Browse Deals",
  "nav.nearExpiry": "Near Expiry",
  "nav.categories": "Categories",
  "nav.businesses": "Businesses",
  "nav.favourites": "Favourites",
  "nav.following": "Following",
  "follows.title": "Following",
  "follows.subtitle": "Every shop and place you follow, in one spot. We'll nudge you when they post something new.",
  "follows.businesses": "Shops you follow ({n})",
  "follows.places": "Places you follow ({n})",
  "follows.followPlace": "Follow this place",
  "follows.following": "Following",
  "follows.nowFollowing": "Following {name}",
  "follows.unfollowed": "Unfollowed {name}",
  "follows.placeNudge": "We'll tell you when any shop here posts a new deal.",
  "follows.signIn": "Sign in to follow shops and places",
  "follows.createAccount": "Create a free account",
  "follows.emptyTitle": "You're not following anyone yet",
  "follows.emptyBody": "Follow a shop or a plaza and new deals will come to you.",
  "nav.myDeals": "My Deals",
  "nav.lytemap": "LyteMap",
  "nav.postDeal": "Post a Deal",
  "nav.analytics": "Analytics",
  "nav.admin": "Admin",
  "nav.ourStory": "Our Story",
  "nav.myAccount": "My Account",
  "nav.pricing": "Pricing",

  "brand.tagline": "Save More. Waste Less.",

  "sidebar.businessLogin": "Log In",
  "sidebar.signupFree": "New here? Sign up free",
  "sidebar.proActive": "Pro active",
  "sidebar.until": "Until {date}",
  "sidebar.growPro": "Grow with Pro",
  "sidebar.growProDesc": "Featured placement, unlimited deals and full analytics.",
  "sidebar.goPremium": "Go Premium",

  "topbar.searchPlaceholder": "Search deals, businesses or categories...",
  "topbar.aiPlaceholder": "Ask AI: cheap dinner near me…",
  "topbar.askAi": "Ask AI",
  "topbar.nearMe": "Near Me",
  "topbar.anywhere": "Anywhere",
  "topbar.country": "Country",
  "topbar.city": "City",
  "topbar.allCities": "All cities",
  "topbar.useMyLocation": "Use my location",
  "topbar.privacyNote": "We use your device location, not your IP address — it stays private and stays accurate even on a VPN.",
  "topbar.typePlace": "or type a city or place…",
  "topbar.clearEverywhere": "Clear — show deals everywhere",
  "topbar.notifications": "Notifications",
  "topbar.more": "More options",
  "topbar.darkMode": "Dark mode",
  "topbar.lightMode": "Light mode",
  "topbar.recent": "{n} recent",
  "topbar.noNotifs": "No notifications yet.",
  "topbar.clearAll": "Clear all",
  "topbar.dismiss": "Dismiss",
  "topbar.viewAllDeals": "View all deals",
  "topbar.hello": "Hello, {name}",
  "topbar.login": "Log in",
  "topbar.try": "Try:",

  "footer.contact": "Contact",
  "footer.terms": "Terms of Use",
  "footer.privacy": "Privacy Policy",
  "footer.pricing": "Pricing",
  "footer.refunds": "Refund Policy",
  "af.footerLink": "Analytics",
  "af.badge": "Shop analytics",
  "af.title": "What your analytics show you",
  "af.subtitle": "Every shop gets the headline numbers. Pro and Elite add the coaching layer — trends, timing and benchmarks.",
  "af.colMetric": "What you see",
  "af.colFree": "Free",
  "af.colPaid": "Pro & Elite",
  "af.rowActions": "“Do this next” — the fixes worth making, from your own numbers",
  "af.onePick": "1 of 3",
  "af.rowDealTable": "One table: every deal with views and grabs",
  "af.rowCompetition": "Nearby rivals and their discounts, side by side",
  "af.rowTotals": "Deals live, expired and near expiry",
  "af.rowTraffic": "Total views, grabs, shares and followers",
  "af.rowDiscount": "Average discount and conversion rate",
  "af.rowFunnel": "Funnel: views to grabs to redeemed",
  "af.rowRedemptions": "Total redemptions and directions taken",
  "af.rowGoal": "Monthly redemption goal tracker",
  "af.rowTrends": "Views, redemption, share and follower trends",
  "af.rowRedemptionDetail": "Redemptions, rate and shares for every deal",
  "af.rowBestTime": "Best time and best day to post",
  "af.rowWoW": "Week-over-week movement",
  "af.rowBenchmark": "How your discounts compare to nearby shops",
  "af.note": "Pro and Elite see exactly the same analytics — there is nothing kept back for the bigger plan. On Free the locked rows still appear, blurred, so you always know what is there.",
  "af.seePlans": "See plans and prices",
  "af.openMine": "Open my analytics",
  "af.compareLink": "See what analytics each plan gives you",


  "home.todaysBest": "Today's best deals",
  "home.upToOff": "Up to {n}% off",
  "home.explore": "Explore Deals",
  "home.browseCategories": "Browse categories",
  "home.eduHeroA": "Learn for",
  "home.eduHeroB": "Less.",
  "home.eduHeroSub": "Find tutoring, courses and classes near you — at prices that make the grade.",
  "home.liveDeals": "{n} live deals",
  "home.categoriesCount": "{n} categories",
  "home.shopByCategory": "Shop by Category",
  "home.viewAll": "View all",
  "home.featuredDeals": "⭐ Featured deals",
  "home.featuredNearYou": "⭐ Featured",
  "home.featuredIn": "⭐ Featured in {place}",
  "home.topDeals": "Top Deals",
  "home.topDealsNear": "Top Deals Near {place}",
  "home.topDealsNearYou": "Top Deals Near You",
  "home.locPromptTitle": "See deals right around you",
  "home.locPromptDesc": "Share your location and we'll put the closest deals — with distances — at the top of your home page.",
  "home.shareLocation": "Share location",
  "home.locating": "Locating…",

  "tourist.visitingTitle": "Visiting the area?",
  "tourist.visitingDesc": "Turn on Tourist Mode to see the best deals near you, in your own currency, with one-tap directions.",
  "tourist.imVisiting": "I'm visiting",

  "rail.yourLocation": "Your Location",
  "rail.change": "Change",
  "rail.featuredDeal": "Featured Deal",
  "rail.viewDeal": "View Deal",
  "rail.nearExpiry": "Near Expiry",
  "rail.lastChance": "(Last Chance!)",
  "rail.viewAll": "View all",
  "rail.noNearExpiry": "No near-expiry items right now.",
  "rail.getAlerts": "Get Deal Alerts",
  "rail.getAlertsDesc": "Be the first to know about new deals and flash sales!",
  "rail.enableAlerts": "Enable Alerts",

  "lang.label": "Language",

  "cat.All": "All",
  "cat.Food": "Food",
  "cat.Drinks": "Drinks",
  "cat.Health": "Health",
  "cat.Events": "Events",
  "cat.Lodging": "Lodging",
  "cat.Services": "Services",
  "cat.Pets": "Pets",
  "cat.Beauty": "Beauty",
  "cat.Tech": "Tech",
  "cat.Near Expiry": "Near Expiry",
  "cat.Upcoming": "Upcoming",
  "cat.Automotive": "Automotive",
  "cat.Fitness": "Fitness",
  "cat.Clothing": "Clothing",
  "cat.Plants": "Plants",
  "cat.Education": "Education",
  "cat.Farm & Livestock": "Farm & Livestock",
  "cat.Travel & Tours": "Travel & Tours",
  "cat.Other": "Other",
  "cat.More": "More",
  "time.expired": "Expired",
  "time.dLeft": "{d}d {h}h left",
  "time.hLeft": "{h}h {m}m left",
  "time.mLeft": "{m}m {s}s left",
  "card.save": "Save {amount}",
  "card.review": "{n} review",
  "card.reviews": "{n} reviews",
  "map.dealsHere": "{n} deals here",
  "map.dealsAtSpot": "{n} deals at this spot",
  "map.businessesHere": "{n} businesses",
  "map.endsSoon": "ends soon",
  "map.viewDeal": "View Deal",
  "map.directions": "Directions",
  "map.branchOf": "1 of {n} branches",
  "map.approx": "{amount} approx.",
  "map.subtitleGps": "Deals around {place} — search another place in the top bar to move the map.",
  "map.subtitle": "Share your location to instantly see deals near you, or search a city / pick a country in the top bar.",
  "map.yourLocation": "your location",
  "map.jumpTo": "Jump to:",
  "map.autoDetected": "Showing deals in {country} — not right?",
  "map.change": "Change",
  "map.maybeLaterBrowse": "Maybe later — browse {place}",
  "map.allDeals": "all deals",
  "map.endingSoon": "Ending soon",
  "map.inView": "In view",
  "map.all": "All",
  "map.inViewCount": "{n} of {m} in view",
  "map.nearbyCount": "{n} of {m} nearby",
  "map.dealCount": "{n} deals",
  "map.dealCountNearby": "{n} deals nearby",
  "map.fitAll": "Fit all deals",
  "map.geoTitle": "See deals near you",
  "map.geoDesc": "Share your location and we'll instantly show the best deals around you on the map.",
  "map.emptyFilter": "No deals match this filter here yet.",
  "map.emptyGps": "No deals near this location yet — try a different place or explore by country.",
  "map.emptyCountry": "No deals in {country} yet.",
  "map.emptyInView": "No deals in this part of the map.",
  "map.zoomOut": "Zoom out to see all {n}",
  "map.myLocation": "Your location",
  "map.expandMap": "Expand map",
  "map.showList": "Show deals",
  "map.openNow": "Open now",
  "map.openBadge": "Open now",
  "map.closedBadge": "Closed now",
  "map.heatmap": "Savings heat",
  "map.heatLegend": "Deepest discounts in this area",
  "map.shareView": "Share this view",
  "map.shareTitle": "Deals on LytePress",
  "map.linkCopied": "Link copied — share it anywhere",
  "map.sharedView": "Showing a shared map view",
  "map.world": "World",
  "map.shopsHere": "{n} shops",
  "map.sharedAddress": "{n} shops at this address",
  "spot.eyebrow": "All deals at this address",
  "spot.fallbackTitle": "This address",
  "spot.dealCount": "{n} deals",
  "spot.visitShop": "Visit shop",
  "spot.seeAll": "See all",
  "spot.backToMap": "Back to LyteMap",
  "spot.gone": "No live deals at this address right now.",
  "spot.share": "Share these deals",
  "spot.shareCopied": "Copied — paste it anywhere",
  "spot.shareHead": "{name} — {shops} shops, {deals} deals on LytePress right now:",
  "spot.shareMore": "…and {n} more",
  "map.noDealsRegion": "No deals in this region yet — be the first to spot one.",
  "invite.cta": "Invite a business",
  "invite.title": "Invite a business to LytePress",
  "invite.subtitle": "Know a shop with deals worth sharing? Tell us and we'll invite them.",
  "invite.namePh": "Business name",
  "invite.cityPh": "Town or city",
  "invite.countryPh": "Country",
  "invite.emailPh": "Their email (optional)",
  "invite.notePh": "Why should shoppers know about them? (optional)",
  "invite.submit": "Send invite",
  "invite.privacy": "We only use these details to invite the business. No account is created for them.",
  "invite.sentEmail": "Invite emailed",
  "invite.logged": "Thanks — noted!",
  "invite.nudge": "A personal message works best. Send them this:",
  "invite.shareMsg": "Hey {name}! Put your deals on LytePress so shoppers nearby can find you — it's free to start: {url}",
  "invite.whatsapp": "Send on WhatsApp",
  "invite.copy": "Copy message",
  "invite.failed": "Could not send that invite. Please try again.",
  "map.citiesIn": "Cities in {country}:",
  "map.allOf": "All of {country}",
  "map.moreCountries": "+{n} more countries",
  "map.fewerCountries": "Show fewer",
  "map.countriesIn": "Countries in {region}:",
  "reg.Caribbean": "Caribbean",
  "reg.North America": "North America",
  "reg.Central America": "Central America",
  "reg.South America": "South America",
  "reg.Europe": "Europe",
  "reg.Middle East": "Middle East",
  "reg.Africa": "Africa",
  "reg.Asia": "Asia",
  "reg.Oceania": "Oceania",
  "reg.Other": "Other",
  "pd.postTitle": "Post a Deal",
  "pd.editTitle": "Edit Deal",
  "pd.dealTitle": "Deal title",
  "pd.dealTitlePh": "e.g. 2-for-1 Large Pizzas",
  "pd.photos": "Deal photos",
  "pd.photosHint": "(up to 6 - shoppers can swipe through)",
  "pd.cover": "Cover",
  "pd.category": "Category",
  "pd.currency": "Currency",
  "pd.redeemHow": "How is this deal redeemed?",
  "pd.inPerson": "In person",
  "pd.onlineOnly": "Online only",
  "pd.onlineNote": "No map pin needed - shoppers worldwide can see this one",
  "pd.promoLabel": "Promo code shoppers use at checkout",
  "pd.promoHint": "Kept hidden until a shopper grabs the deal, then shown with a one-tap copy button. Make sure it works on your website.",
  "pd.whichLocations": "Which of your locations does this deal apply to?",
  "pd.pinLabel": "Pin deal location(s) on the map",
  "pd.description": "Description",
  "pd.descriptionPh": "Describe the offer...",
  "pd.dealType": "Deal type",
  "pd.percentOff": "Percentage off (%)",
  "pd.setPrice": "Set price",
  "pd.originalPrice": "Original price ({sym})",
  "pd.dealPrice": "Deal price ({sym})",
  "pd.discountPct": "Discount (%)",
  "pd.terms": "Terms & conditions",
  "pd2.writeForMe": "Write it for me",
  "pd2.photoFirst": "Add a photo first and the draft will describe what's actually in it.",
  "pd2.draftNoPhoto": "Written from the title alone — add a photo for a sharper draft.",
  "pd2.undoDraft": "Undo",
  "pd2.titleSuggested": "Sharper title:",
  "pd2.useTitle": "Use it",
  "pd2.dismissTitle": "Keep mine",
  "pd2.undoTitleChange": "Undo title",
  "pd2.draftFailed": "Could not write a draft just now",
  "pd2.descHint": "Shoppers decide from this. {n} more characters needed.",
  "pd2.descOk": "Shoppers decide from this one — good length.",
  "pd2.moreOptions": "More options",
  "pd2.moreHint": "These stay as you left them last time, so most deals need nothing but a photo, a title and a price.",
  "pd2.codesOn": "codes on",
  "pd2.featuredOn": "featured",
  "pd2.endToday": "Today",
  "pd2.end3": "3 days",
  "pd2.end7": "7 days",
  "pd2.end14": "14 days",
  "pd2.endPick": "Pick a date",
  "pd2.endsAt": "Ends {date} at {time} ({gmt})",
  "pd2.exactTime": "Exact end time",
  "pd2.addSpot": "Pin a different spot",
  "pd.endsOn": "Ends on",
  "pd.lastChance": "Last Chance",
  "pd.lastChanceNote": "is automatic - your deal joins that list on its own once it has under 48 hours left.",
  "pd.shortDated": "Short-dated stock",
  "pd.shortDatedHint": "For stock near its best-before or expiry date - food, drinks, supplements, medication, cosmetics, engine oil, batteries, seeds, ink. Shoppers see a Short-dated badge; being upfront sells it faster and cuts waste.",
  "pd.bestBefore": "Best before (optional)",
  "pd.feature": "Feature this deal",
  "pd.timezone": "Time zone",
  "pd.publishAt": "Publish at",
  "pd.publishHint": "Leave blank to go live immediately.",
  "pd.publish": "Publish Deal",
  "pd.saveChanges": "Save changes",
  "pd.promoNeeded": "Promo code needed",
  "pd.promoNeededMsg": "Online deals are redeemed with a promo code - add the code shoppers should use at checkout.",
  "pd.addDiscount": "Add a discount",
  "pd.addDiscountMsg": "Enter how many percent off this deal is (1-100).",
  "pd.subtitle": "Share a promotion or near-expiry offer with your community.",
  "pd.upload": "Tap to upload or take photos",
  "pd.uploadHint": "JPG, PNG or WEBP up to 8MB each",
  "pd.branchHint": "Tick to include a saved location. You can also add a custom pin on the map below.",
  "picker.searchPh": "Search an address or place...",
  "picker.find": "Find",
  "picker.gps": "Use my GPS",
  "picker.hint": "Search, use GPS, or tap the map to drop a pin. Drag a pin to fine-tune the exact spot.",
  "picker.namedPre": "We named this pin",
  "picker.editName": "Not right? Tap to edit the name shoppers see",
  "pd.editSubtitle": "Tweak the price, dates or details, then publish your updated deal.",
  "pd.uploading": "Uploading...",
  "pd.pinHint": "- add a branch pin for each spot this deal is available. The location(s) come from your business profile (a deal can override them below).",
  "pd.codeReq": "Require a redemption code in-store",
  "pd.codeReqHint": "Shoppers get a unique code & QR to show at checkout. You confirm it from My Account - track exactly how many customers LytePress sent you.",
  "pd.schedule": "Schedule when it goes live",
  "pd.scheduleHint": "Auto-publish at an exact time in a chosen time zone. Leave off to publish now. Expiry uses the Ends on date above.",
  "pd.branchFooter": "Optional - if you skip this, we'll place the deal at your business's registered location ({place}). Manage your opening hours in",
  "pd.beating": "Beating {rival}",
  "pd.beatingMsg": "Their '{title}' is {rivalDiscount}% off - we've drafted a sharper {discount}% off deal. Tweak and publish to win the shopper.",
  "pd.termsDefault": "Valid while stocks last. Cannot be combined with other offers.",
  "common.percentOff": "{n}% off",
  "common.tryAgain": "Please try again.",

  "browse.title": "Browse Deals",
  "browse.nearYou": "Deals Near You",
  "browse.nearPlace": "Deals Near {place}",
  "browse.sortedFrom": "Sorted by distance from {place}.",
  "browse.bestLocal": "Best local savings in {place}.",
  "browse.worldwide": "Great deals from around the world.",
  "browse.radius": "Distance radius",
  "browse.openNow": "Open now",
  "browse.online": "Online",
  "browse.shortDated": "Short-dated",
  "browse.clearSearch": "Clear search",
  "browse.aiNoMatch": "No deals matched that search. Try rephrasing — e.g. “restaurant deals under $20” or “electronics near me”.",
  "browse.aiUnavailable": "AI search is unavailable right now — showing your browse results.",
  "browse.searchFilters": "Filters from your search:",
  "browse.noDeals": "No deals here yet",
  "browse.noMatch": "Nothing matches “{q}”. Try different words or another category.",
  "browse.closestMatches": "No exact match for “{q}” — here are the closest deals.",
  "browse.didYouMean": "Search “{q}” instead",
  "trending.label": "Trending near you",
  "saved.cta": "Save this search",
  "saved.saved": "Search saved",
  "saved.section": "Saved searches ({n})",
  "saved.done": "Saved “{q}”",
  "saved.doneBody": "We'll nudge you when a matching deal appears.",
  "saved.removed": "Removed “{q}”",
  "saved.signIn": "Sign in to save searches",
  "browse.browseCats": "Browse categories",
  "browse.emptyOpenNow": "No deals from businesses open right now. Try turning off “Open now”.",
  "browse.emptyShortDated": "No short-dated deals right now — check back, they appear as shops mark down stock near its date.",
  "browse.emptyOnline": "No online-only deals yet — turn the Online filter off to see deals near you.",
  "browse.emptyRadius": "No deals within {radius} of you. Try widening the radius.",
  "browse.emptyRadiusPlace": "No deals within {radius} of {place}. Try widening the radius.",
  "browse.emptyDefault": "No deals match your filters yet. Try clearing a filter or exploring another category.",
  "browse.firstBusiness": "Be the first business in {place}",
  "browse.firstBusinessMsg": "Nobody has posted here yet — the first deal gets every shopper who arrives, and your business sits alone at the top of the map.",
  "browse.postFirst": "Post the first deal",
  "browse.yourArea": "your area",

  "card.lastChance": "Last Chance",
  "card.shortDated": "Short-dated",
  "card.online": "Online deal",
  "card.directions": "Get directions",
  "card.favourite": "Add to favourites",
  "card.inYourCurrency": "in your currency",
  "card.locations": "{n} locations",

  "fav.title": "Favourites",
  "fav.subtitle": "Deals you've saved for later.",
  "fav.emptyTitle": "No favourites yet",
  "fav.emptyMsg": "Tap the heart on any deal to save it here.",
  "fav.browse": "Browse Deals",

  "cats.heading": "What are you shopping for?",
  "cats.allDeals": "All deals",
  "cats.endingSoon": "Ending Soon",

  "mydeals.guestTitle": "Your grabbed deals live here",
  "mydeals.guestMsg": "Sign in free and every deal you grab — codes, QR passes and offers — is saved here on all your devices, with reminders before they end.",
  "mydeals.createAccount": "Create free account",
  "mydeals.businessTitle": "My Deals is for shoppers",
  "mydeals.businessMsg": "Manage the deals you've posted from your dashboard.",
  "mydeals.goDashboard": "Go to dashboard",
  "mydeals.title": "My Deals",
  "mydeals.subtitle": "Every deal you've grabbed — show these at the business to redeem.",
  "mydeals.emptyTitle": "No deals grabbed yet",
  "mydeals.emptyMsg": "Tap \"Grab Deal\" on any offer and it'll appear here with your code, a countdown and directions to the shop.",
  "mydeals.ready": "Ready to redeem",
  "mydeals.nothingWaiting": "Nothing waiting —",
  "mydeals.grabNew": "grab a new deal",
  "mydeals.redeemedOn": "redeemed on {date}",
  "mydeals.youSavedAmount": "you saved {amount}",
  "mydeals.youSavedTotal": "You've saved {amount}",
  "mydeals.redeemed": "Redeemed",
  "mydeals.ended": "Ended",
  "mydeals.dealEnded": "This deal has ended",
  "mydeals.toRedeem": "{time} to redeem",
  "mydeals.noExpiry": "No expiry — redeem any time",
  "mydeals.showAtCheckout": "Show at checkout",
  "mydeals.useOnlineCode": "Use your code at their online checkout",
  "mydeals.showAtBusiness": "Show this deal at {business}",
  "mydeals.shortDated": "Short-dated",
  "mydeals.useBy": "use by {date}",
  "mydeals.copy": "Copy",
  "mydeals.codeCopied": "Code copied",
  "mydeals.pasteAt": "Paste {code} at checkout.",
  "mydeals.yourCode": "Here's your code",
  "mydeals.undone": "Grab undone",
  "mydeals.undoneMsg": "“{title}” was removed from My Deals.",
  "mydeals.undoFailed": "Couldn't undo",

  "nearexp.subtitle": "Grab these before they're gone — save big and cut waste.",
  "nearexp.grab": "Grab Deal",
  "nearexp.emptyTitle": "Nothing expiring right now",
  "nearexp.emptyMsg": "There are no last-chance deals at the moment. Check back soon — they appear as deals near their end date.",
  "nearexp.browseAll": "Browse all deals",

  "deal.notFound": "Deal not found.",
  "deal.back": "Back to deals",
  "deal.featured": "FEATURED",
  "deal.zoom": "View full image",
  "deal.zoomHint": "Pinch or double-tap to zoom",
  "deal.zoomReset": "Double-tap to reset",
  "deal.translate": "Translate",
  "deal.translated": "Translated",
  "deal.translateFail": "Translation unavailable",
  "deal.inYourCurrency": "in your currency",
  "deal.shortDatedTitle": "Short-dated stock",
  "deal.shortDatedUseBy": "use by {date}",
  "deal.shortDatedNote": "Still perfectly good, priced down so it gets used instead of binned. Check the date suits you before you buy.",
  "deal.onlineTitle": "Online deal",
  "deal.onlineMsg": "No store visit needed — grab the deal to reveal your promo code, then use it at {business}'s online checkout.",
  "deal.onlineWorldwide": "Available to shoppers anywhere in the world.",
  "deal.onlineBadge": "Online deal · redeem anywhere",
  "deal.grab": "Grab Deal",
  "deal.getCode": "Get my redemption code",
  "deal.getPromo": "Get my promo code",
  "deal.signInGrab": "Sign in free & grab deal",
  "deal.grabbed": "Deal grabbed!",
  "deal.promoUse": "Use this promo code at {business}'s online checkout:",
  "deal.copyCode": "Copy code",
  "deal.savedInPre": "Saved in",
  "deal.savedUntilExpiry": "until it expires.",
  "deal.visitToRedeem": "Visit {business} in {location} to redeem this offer before it ends.",
  "deal.loginHint": "Free shopper account · takes 10 seconds · we'll bring you straight back",
  "deal.signInToGrab": "Sign in to grab this deal",
  "deal.signInToGrabMsg": "Create a free shopper account — we'll bring you right back to this deal.",
  "deal.couldNotGrab": "Could not grab deal",
  "deal.codeCopied": "Code copied",
  "deal.pasteAt": "Paste {code} at checkout.",
  "deal.grabUndone": "Grab undone",
  "deal.grabUndoneMsg": "No worries — the deal is still here if you change your mind.",
  "deal.mapUnavailable": "Map unavailable",
  "deal.location": "Location",
  "deal.availableAt": "Available at {n} locations",
  "deal.directions": "Get directions",
  "deal.terms": "Terms & Conditions",
  "deal.staffCode": "Staff at {business} will enter this code to apply your discount. One-time use — find it again in",
  "deal.myDeals": "My Deals",
  "deal.views": "{n} views",

  "auth.verify": "Verify",
  "auth.login": "Log In",
  "auth.welcomeBack": "Welcome back to LytePress.",
  "auth.email": "Email",
  "auth.password": "Password",
  "auth.forgot":  "Forgot password?",
  "auth.backToLogin": "Back to login",
  "auth.demoLabel": "Demo:",

  "auth.newShopper": "New shopper?",
  "auth.createFree": "Create a free account",
  "auth.areBusiness": "Are you a business?",
  "auth.registerBusiness": "Register your business",
  "auth.welcomeBackToast": "Welcome back!",
  "auth.signedInAs": "Signed in as {name}",
  "auth.loginFailed": "Login failed",
  "auth.invalidCreds": "Invalid credentials",
  "auth.mfaTitle": "Two-factor verification",
  "auth.mfaMsg": "Enter the 6-digit code from your authenticator app, or use a recovery code.",
  "auth.mfaPlaceholder": "123456 or recovery code",
  "auth.trustDevice": "Trust this device for 30 days",
  "auth.skip2fa": "(skip 2FA next time)",
  "auth.signupTitle": "Create your free account",
  "auth.signupMsg": "Follow your favourite businesses and get notified the moment they post a deal.",
  "auth.yourName": "Your name",
  "pw.placeholder8": "Password (8+ chars, one capital, one symbol)",
  "pw.placeholder12": "Password (12+ chars, one capital, one symbol)",
  "pw.acceptWeak": "I understand this password is weak and I want to use it anyway",
  "pw.suggest": "Suggest a password for me",
  "pw.memorable": "Memorable",
  "pw.random": "Random",
  "pw.words": "Words:",
  "pw.reroll": "New suggestion",
  "pw.copy": "Copy",
  "pw.suggestNote": "Use it, then save it somewhere safe. It already meets our strength rules.",
  "auth.staffPortal": "Staff portal",
  "auth.staffSignIn": "Staff sign-in",
  "auth.staffPortalNote": "Sign in with your admin account.",
  "pw.leaked": "Seen in {n} known data breaches — attackers try these first.",
  "pw.floorNote": "Every password needs at least 8 characters, one capital letter and one symbol.",
  "auth.passwordMin": "Password (at least 8 characters)",
  "auth.agreeTo": "By creating an account you agree to our",
  "auth.agreeCheckbox": "I have read and agree to the",
  "auth.and": "and",
  "auth.haveAccount": "Already have an account?",
  "auth.logIn": "Log in",
  "auth.signupFailed": "Sign up failed",
  "auth.welcomeToLyte": "Welcome to LytePress!",
  "qa.fixTitle": "Let's tidy this up first",
  "qa.uploadBlocked": "Photo not accepted",
  "qa.pending": "Sent for review",
  "qa.pendingMsg": "Your deal will go live as soon as our team approves it.",
  "ver.title": "Confirm your email to publish deals",
  "ver.note": "We sent a link and a 6-digit code to {email}. Deals you post are parked until you confirm — they go live the moment you do.",
  "ver.domainTip": "Tip: confirming an address on your own business domain (not Gmail or Hotmail) lifts your live-deal and location limits straight away.",
  "br.pinFarFromListing": "{branch} is pinned about {distance} km from the Google listing we found under your name — {listing}, {address}. If the pin is wrong, shoppers tapping Directions are sent somewhere you aren't. Drag it onto your door and save.",
  "br.thisPin": "This pin",
  "fx.title": "Move this pin?",
  "fx.summary": "{business} has {branch} pinned about {distance} km from the Google listing we found under your name — {listing}{address}.",
  "fx.legend": "Red is where your pin is now. Green is the listing. Confirming moves the saved pin and the same pin on your live deals. If your pin is right and the listing belongs to somebody else, just close this page — nothing changes.",
  "fx.confirm": "Yes, move my pin here",
  "fx.now": "Now",
  "fx.listing": "Listing",
  "fx.moved": "Pin moved",
  "fx.movedNote": "{branch} now sits at {address}. Your live deals were updated too, so Directions sends shoppers to the right place from now on.",
  "fx.yourPin": "Your pin",
  "fx.yourListing": "your Google listing",
  "fx.aLocation": "a location",
  "fx.expired": "That link has expired",
  "fx.expiredNote": "One-tap links last 14 days. You can still move the pin yourself from My Account.",
  "fx.cantUse": "We can't use that link",
  "fx.checking": "Checking that link…",
  "fx.noCode": "That link is missing its code. Open the email again.",
  "fx.invalid": "That link isn't valid any more.",
  "fx.failed": "Could not move that pin.",
  "fx.openAccount": "Open My Account",
  "fx.byHand": "to move any pin by hand.",
  "ver.codePlaceholder": "000000",
  "ver.confirmCode": "Confirm",
  "ver.resend": "Send it again",
  "ver.sent": "Email on its way",
  "ver.sentNote": "Check {email} — the link and the code both work.",
  "ver.couldNotSend": "Could not send that email",
  "ver.badCode": "That code did not work",
  "ver.done": "Email confirmed",
  "ver.doneNote": "You are all set — anything you had parked is going live now.",
  "ver.checking": "Confirming your email...",
  "ver.badLink": "That link did not work",
  "ver.badLinkNote": "It may have expired or already been used.",
  "ver.useCodeInstead": "Type the 6-digit code from the email into the banner on your dashboard instead.",
  "ver.noToken": "This link is missing its code.",
  "ver.enterCodeHere": "Type the 6-digit code from the email here",
  "ver.manualTitle": "Confirm your email",
  "ver.manualNote": "Open the email we sent you and type its 6-digit code below. No need to be signed in.",
  "ver.needANewOne": "Lost the email, or the code has expired?",
  "ver.emailPlaceholder": "The email you signed up with",
  "ver.sendNewEmail": "Send a new email",
  "ver.emailSentShort": "Email sent",
  "ver.goToAccount": "Go to my account",
  "qa.emailPending": "Confirm your email first",
  "qa.emailPendingMsg": "Your deal is saved and parked. Tap the link in the email we sent you — or type the 6-digit code into the banner on your dashboard — and it goes live straight away.",
  "qa.firstDealPending": "First deal — in review",
  "qa.firstDealPendingMsg": "We take a quick look at a new shop's first deal before it hits the map. It usually goes live within a couple of hours, and every deal after this one publishes straight away.",
  "rpt.notHonoured": "Deal wasn't honoured",
  "rpt.notHonouredSent": "Report sent",
  "rpt.notHonouredThanks": "Thanks for telling us",
  "rpt.notHonouredNote": "This goes straight to our moderation team and we follow it up with the shop.",
  "rpt.notHonouredHelp": "Went in and the shop refused this deal? One tap tells us — no form to fill in.",
  "qa.watchNotice": "Your deals are reviewed before they go live. Post as normal — we usually approve within a few hours.",
  "qa.title_short": "Give the deal a real title (at least 6 characters) so shoppers know what it is.",
  "qa.title_long": "That title is too long — keep it under 90 characters.",
  "qa.title_caps": "Please don't write the title in ALL CAPS — it reads as spam.",
  "qa.title_emoji": "Too many emojis in the title — keep it to two at most.",
  "qa.desc_short": "Add a short description (at least 20 characters) telling shoppers what they get.",
  "qa.profanity": "Please take the swearing out first — we found {words}. LytePress is read by families and shopfront staff, so deals and reviews stay clean.",
  "qa.banned": "That wording isn't allowed on LytePress. Please remove restricted or adult content.",
  "qa.links": "Links and social handles aren't allowed in the description — shoppers contact you from your profile, where your details already live.",
  "qa.phone": "Please leave phone numbers out of the description — add them to your business profile instead.",
  "qa.price_invalid": "Price and was-price must be numbers.",
  "qa.disc_high": "A discount above {max}% isn't believable — shoppers report these. Please correct it.",
  "qa.was_low": "The 'was' price must be higher than the deal price.",
  "qa.disc_mismatch": "Your % off doesn't match the prices — {price} from {was} is {computed}% off, not {discount}%.",
  "qa.dup_title": "You already have a live deal with this exact title — edit that one or give this a different title.",
  "qa.img_small": "That photo is only {w}×{h}px — shoppers would see a blurry card. Please upload at least {minW}×{minH}px.",
  "qa.img_blank": "That image looks blank or almost one solid colour. Please upload a real photo of what's on offer.",
  "qa.img_blurry": "That photo looks out of focus. Please upload a sharper photo so shoppers can see the offer clearly.",
  "qa.img_unreadable": "We couldn't read that image. Please upload a JPG, PNG or WebP photo.",
  "qa.img_duplicate": "That photo is already in use by another business on LytePress. Please upload your own photo of the offer.",
  "qa.ai_blocked": "Our content check blocked this deal (adult or graphic content). If you believe this is a mistake, contact support@lytepress.com.",
  "qa.planLimit": "You've hit your plan's deal limit",
  "qa.seePlans": "See plans",
  "qa.coachGood": "Looks great",
  "qa.coachChecking": "Checking photo…",
  "qa.coachSmall": "Too small ({w}×{h}px) — needs {minW}×{minH}px",
  "qa.coachBlurry": "Looks out of focus — try a sharper photo",
  "qa.coachBlank": "Looks blank — upload a real photo of the offer",
  "invite.signInTitle": "Sign in to nominate a shop",
  "invite.signInMsg": "Free accounts take a few seconds — it keeps invites genuine.",
  "prc.badge": "Plans for businesses",
  "prc.h1": "Grow faster with LytePress",
  "prc.sub": "Post more deals, get seen first, and see exactly how you stack up against the shop down the road.",
  "prc.chipFeatured": "Priority placement",
  "prc.chipAnalytics": "Full analytics",
  "prc.chipCredits": "Boosts & Featured as add-ons",
  "prc.yourPlan": "Your plan: {plan}",
  "prc.dealsUsed": "{used} of {limit} deals posted this month",
  "prc.unlimited": "unlimited",
  "prc.boostLeft": "{n} Boost Passes held",
  "prc.monthly": "Monthly",
  "prc.yearly": "Yearly",
  "prc.save17": "save 17%",
  "prc.free": "Free",
  "prc.freeSub": "Get started",
  "prc.f1": "4 deals a month, resets on the 1st, up to 14 days each",
  "prc.f2": "One map pin & public profile",
  "prc.f3": "Views tracking",
  "prc.currentPlan": "Your current plan",
  "prc.startFree": "Start free — no card needed",
  "prc.rollFree": "Resets on the 1st. Free doesn't bank unused deals.",
  "prc.rollPro": "Unused deals bank for one month, up to 30 — so a quiet month can leave you 60 to post next month.",
  "prc.rollPlus": "Unused deals bank for one month, up to 150 — so a quiet month can leave you 300 to post next month.",
  "prc.rollAddon": "Extra deals bought as add-ons never expire.",
  "prc.rolledIn": "{n} rolled over from last month",
  "del.title": "Delete my account",
  "msg.title": "Messages",
  "msg.sub": "Anything we send you lands here — reply in the app and it comes straight to us.",
  "msg.new": "new",
  "msg.noSubject": "Message",
  "msg.you": "You",
  "msg.replyPlaceholder": "Write your reply…",
  "msg.send": "Send reply",
  "msg.sent": "Reply sent — we'll come back to you.",
  "sec.nudgeTitle": "Lock your shop with a passkey",
  "sec.nudgeBody": "Your account holds your deals, your pricing and your payment history. A passkey (Face ID or fingerprint) or two-step code makes a stolen password useless.",
  "sec.nudgePasskey": "Add a passkey",
  "sec.nudge2fa": "Turn on two-step",
  "del.subShopper": "Removes your account, saved codes, favourites and sessions. Reviews you left stay on the shop as “Deleted user”.",
  "del.subBusiness": "You can delete once you have no live or scheduled deals and no paid term still running. Everything then goes: your shop, deals, photos and pins.",
  "del.cta": "Delete my account",
  "del.warning": "This is permanent. We can't bring the account, your deals or your photos back.",
  "del.passwordPlaceholder": "Your password",
  "del.typeDelete": "Type DELETE to confirm",
  "del.confirmCta": "Delete permanently",
  "del.keepAccount": "Keep my account",
  "del.done": "Account deleted",
  "del.doneNote": "Everything has been removed. Thanks for giving LytePress a try.",
  "prc.switchAtTermEnd": "Switch to {plan} when my term ends",
  "prc.noProration": "No proration — your current term is already paid for, so the switch waits until it ends.",
  "prc.cancelScheduled": "Cancel the scheduled switch",
  "prc.scheduled": "Scheduled: {plan}",
  "prc.scheduledOn": "It takes effect on {date}. Nothing changes before then.",
  "prc.scheduleCancelled": "Scheduled switch cancelled — nothing changes.",
  "prc.scheduledBanner": "You're moving to {plan} on {date}. Everything you've paid for stays active until then.",
  "prc.pro": "Pro",
  "prc.bestValue": "BEST VALUE",
  "prc.perYear": "/ year",
  "prc.per30": "/ 30 days",
  "prc.proYearNote": "That's ~{monthly}/mo — 2 months free",
  "prc.proMonthNote": "or {yearly}/year — save 17%",
  "prc.p1": "30 deals a month — unused ones roll over, up to 30 days each",
  "prc.p2": "Full analytics & competition benchmarking",
  "prc.p3": "Up to 3 pinned locations",
  "prc.p4": "Push new deals to all your followers",
  "prc.p5": "Promotion reports on every Boost or Featured run",
  "prc.plus": "Elite",
  "prc.plusYearNote": "That's {monthly}/mo — 2 months free",
  "prc.plusIncludesPro": "Everything in Pro, plus:",
  "prc.plusMonthNote": "For shops with volume or several branches",
  "prc.b1": "150 deals a month — unused ones roll over, up to 60 days each",
  "prc.b2": "25 pinned locations, and you can buy more",
  "prc.b3": "Priority placement in Browse & the map, shared fairly",
  "prc.b4": "Priority support — your messages jump the queue",
  "prc.b5": "Your own shop link, lytepress.com/s/your-name (verified shops)",
  "prc.activeLife": "Active for life",
  "prc.renewsOn": "Renews on {date}",
  "prc.endsOn": "Ends on {date}",
  "prc.cancelRenewPro": "Cancel auto-renew (keep Pro until it ends)",
  "prc.cancelRenew": "Cancel auto-renew",
  "prc.resumeRenew": "Turn auto-renew back on",
  "prc.goYearly": "Go yearly — {price}",
  "prc.goMonthly": "Go monthly — {price}",
  "prc.guarantee": "14-day money back —",
  "prc.guaranteeLink": "no questions asked",
  "prc.boostTitle": "Need a quick boost?",
  "prc.boostBody": "Boosts and Featured placements are never bundled into a plan — buy them only when you need them. Boost any single deal for {price} to pin it to the top of Browse and the map for 7 days — find the Boost button on your deals in",
  "prc.myAccount": "My Account",
  "prc.boostRefundPre": "Refundable in full before the placement starts — see the",
  "prc.refundPolicy": "Refund Policy",
  "prc.testMode": "Test mode — use card 4242 4242 4242 4242, any future expiry and CVC.",
  "prc.sp1": "All prices in US dollars. Sales tax or VAT may be added at checkout based on your country — you'll see the exact total before you pay.",
  "prc.sp2": "Plans auto-renew so your shop never goes dark. You pay for a term (Pro {pro} / 30 days or {proYear} / year; Elite {plus} / 30 days or {plusYear} / year); your card is saved securely by our payment provider, Stripe, and charged automatically at the start of each new term — until you turn off auto-renew, which you can do any time from this page. If a renewal payment fails, your plan keeps running for a 3-day grace period while we retry. A discount code applies only to the term it is used on — renewals bill at the list price. Plans never include Boosts or Featured placements: those are one-off add-on charges, not subscriptions.",
  "prc.sp3": "Live-deal limits count deals that are published or scheduled and not yet expired — Free 2, Pro 15, Elite 100. Elite also covers 25 pinned locations. Those ceilings are fair use, not a wall: if your chain needs more, email support and we'll raise them on your account. Priority placement is a tie-break between deals that are the same distance from the shopper, shared fairly between Elite shops — it never puts a shop above one that is genuinely closer.",
  "prc.firstTermOnly": "{price} for this term with your code — renews at {full}",
  "prc.promoTermOnly": "Codes apply to the term you buy. Renewals auto-charge at the usual price, so the discount is for this first term only.",
  "prc.sp4pre": "Not sure? Every subscription payment is covered by our",
  "prc.sp4link": "14-day money-back guarantee",
  "prc.sp4post": "Shoppers never pay to use LytePress.",
  "prc.bizOnly": "Business accounts only",
  "prc.bizOnlyMsg": "Paid plans are for businesses that post deals.",
  "prc.checkoutFail": "Could not start checkout",
  "prc.tryAgain": "Please try again.",
  "prc.renewOff": "Auto-renew turned off",
  "prc.renewOn": "Auto-renew turned on",
  "prc.subFail": "Could not update subscription",
  "ck.title": "We use cookies",
  "ck.body": "We use essential cookies to keep LytePress running and optional ones to improve your experience. See our",
  "ck.privacy": "Privacy Policy",
  "ck.acceptAll": "Accept all",
  "ck.essential": "Essential only",
  "ck.dismiss": "Dismiss",
  "undo.label": "Undo",
  "undo.done": "Restored",
  "undo.failed": "Couldn't undo that — please try again",
  "follows.unfollow": "Unfollow",
  "follow.follow": "Follow",
  "follow.following": "Following",
  "follow.now": "Following {name}",
  "follow.nowMsg": "We'll notify you when they post a new deal.",
  "follow.stopped": "Unfollowed {name}",
  "follow.signInTitle": "Sign in to follow",
  "follow.signInMsg": "Create a free shopper account to get deal alerts.",
  "acc.shopperAccount": "Shopper account",
  "acc.verifiedSavingsThisMonth": "Verified savings this month",
  "acc.redeemADealCode": "Redeem a deal code in-store to start banking verified savings.",
  "acc.topSaverEveryBadge": "Top saver — every badge unlocked!",
  "acc.recentRedemptions": "Recent redemptions",
  "acc.showPricesInMy": "Show prices in my currency",
  "acc.dealsShowAnApproximate": "Deals show an approximate price in this currency across the app.",
  "acc.showPricesAsIs": "Show prices as-is",
  "acc.emailPreferences": "Email preferences",
  "acc.newDealAlerts": "New deal alerts",
  "acc.emailMeWhenA": "Email me when a business I follow posts a new deal.",
  "acc.accountSecurityEmailsReceipts": "Account & security emails (receipts, password resets) are always sent.",
  "acc.emailFreqIntro": "How often should we email you about deals and offers?",
  "acc.freq_instant": "As it happens",
  "acc.freq_instant_note": "One email per deal, still capped at one a day so it never floods you.",
  "acc.freq_daily": "Once a day",
  "acc.freq_daily_note": "Everything from the day bundled into one email. Recommended.",
  "acc.freq_weekly": "Once a week",
  "acc.freq_weekly_note": "One round-up a week, nothing in between.",
  "acc.freq_off": "No marketing email",
  "acc.freq_off_note": "Nothing promotional. You'll still see everything in the app.",
  "acc.emailFreqSaved": "Email frequency saved",
  "acc.emailCapNote": "Whatever you pick, we never send more than one marketing email a day or three a week.",
  "acc.rivalAlertsTitle": "Tell me when a rival goes deeper",
  "acc.rivalAlertsNote": "One heads-up a week, at most, when a shop within 10 km in your category posts a deal at least 10 points deeper than your live average. Pro and Elite only.",
  "acc.rivalAlertsOn": "Rival alerts are on",
  "acc.rivalAlertsOff": "Rival alerts are off",
  "acc.quietTitle": "Quiet hours",
  "acc.quietNote": "Nothing promotional lands overnight — it waits for the morning.",
  "acc.quietFrom": "Quiet from",
  "acc.quietTo": "until",
  "acc.quietYourTime": "your local time",
  "acc.quietSaved": "Quiet hours saved",
  "acc.browseDealsArrow": "Browse deals →",
  "acc.verifiedRedemptionsOnly": "Verified in-store redemptions only.",
  "acc.approxIn": "approx. in {cur}",
  "acc.nextEmailAt": "Next email: {when}",
  "acc.nextEmailOff": "We won't email you anything promotional.",
  "acc.nextEmailSoon": "any moment now",
  "acc.nextEmailToday": "today after {time}",
  "acc.nextEmailTomorrow": "tomorrow after {time}",
  "acc.nextEmailWaiting": "{n} waiting to be bundled",
  "an3.withinRadius": "Rivals within",
  "an3.anywhere": "Anywhere",
  "an3.radiusSummary": "{n} rival shops in {cat} with live deals within {km} km of your pin.",
  "an3.radiusSummaryAny": "{n} rival shops in {cat} with live deals, closest first.",
  "an3.noneInRadius": "No rival in {cat} is running a deal within {km} km of you — that space is yours.",
  "an3.noneAnywhere": "No rival in {cat} has a live deal right now — that space is yours.",
  "an3.radiusLocked": "Nearby rivals by distance is a Pro feature.",
  "an3.radiusNoPin": "Pin your shop on the map and we can measure the shops around you.",
  "an3.pinMyShop": "Pin my shop",
  "an3.myCategory": "my category",
  "an3.sameSpot": "Same spot",
  "an3.underTenth": "under 0.2 km",
  "an3.kmAway": "{km} km",
  "an3.nearestOf": "nearest of {n} locations",
  "an3.liveCount": "{n} live",
  "bo.fitShorter": "Your deal ends in {days} days, so this runs {days} instead of {full} — priced to match.",
  "bo.fitTooShort": "This deal ends within a day. Renew or extend it first and the full run is yours.",
  "an3.locationsCount": "{n} locations",
  "an3.locationN": "Location {n}",
  "an3.legendYou": "You",
  "an3.legendRival": "Rival · avg % off",
  "an3.compareRival": "Compare with my deals",
  "an3.rivalsHidden": "{n} rival shops are running deals here.",
  "an3.rivalsHiddenNote": "Pro and Elite show you who they are, how far away they sit and how deep they discount.",

  "acc.myRedemptionCodes": "My redemption codes",
  "acc.businessesYouFollow": "Businesses you follow",
  "acc.youReNotFollowing": "You're not following any businesses yet. Follow a business to get notified when they post a deal.",
  "acc.browseBusinesses": "Browse businesses",
  "sec.title": "Sign-in details",
  "sec.sub": "Change the password or email you sign in with.",
  "sec.pwTitle": "Password",
  "sec.pwNote": "Changing it signs out every other device.",
  "sec.pwCta": "Change password",
  "sec.currentPw": "Current password",
  "sec.newPw": "New password",
  "sec.pwSave": "Save password",
  "sec.pwChanged": "Password changed",
  "sec.pwChangedNote": "Every other device has been signed out.",
  "sec.emailTitle": "Sign-in email",
  "sec.emailCta": "Change email",
  "sec.newEmail": "New email address",
  "sec.emailSave": "Send confirmation",
  "sec.emailConfirmNote": "We'll send a link to the new address. Nothing changes until you tap it.",
  "sec.emailSent": "Check your new inbox",
  "sec.emailSentNote": "We sent a confirmation link to {email}. It works for 24 hours.",
  "sec.emailPending": "Waiting for {email} to confirm.",
  "ses.title": "Signed-in devices",
  "ses.sub": "Sign out anything you don't recognise.",
  "ses.idleNote": "Signed out automatically after {n} hours of doing nothing.",
  "ses.thisDevice": "This device",
  "ses.signOutAll": "Sign out everywhere",
  "ses.signOutDevice": "Sign out this device",
  "ses.signedOutDevice": "That device was signed out",
  "ses.signedOutAll": "Signed out everywhere",
  "ses.signedOutAllNote": "Every other device will need to sign in again.",
  "ses.empty": "No other devices are signed in.",
  "auth.endedIdle": "You were signed out after a period of inactivity. Sign in to pick up where you left off.",
  "auth.endedRevoked": "This device was signed out. Sign in again to continue.",
  "pd.clampedTitle": "End date pulled in",
  "pd.clampedNote": "Your plan runs a deal for up to {n} days, so that's where this one ends. Renew it in one tap to keep it going.",
  "pd.maxDays": "Your plan runs a deal for up to {n} days. Renew it in one tap when it ends.",
  "acc.renew": "Renew",
  "acc.renewTitle": "Put this deal back on the map with a fresh countdown",
  "acc.renewDone": "Countdown reset",
  "acc.renewRelisted": "Back on the map",
  "acc.renewNote": "This deal runs for another {n} days.",
  "nd.title": "No deals here yet",
  "nd.sub": "Tell us where you are and we'll go get shops on the map near you. It's how we decide where to knock next.",
  "nd.townPlaceholder": "Your town, e.g. Arima",
  "nd.emailPlaceholder": "Email (optional — we'll tell you when deals land)",
  "nd.cta": "I want deals here",
  "nd.thanks": "Noted",
  "nd.thanksNote": "We've added {place} to the list.",
  "nd.onTheList": "You're on the list",
  "nd.onTheListNote": "We'll email you the moment shops near you start posting.",
  "map.shareNear": "Share the closest deals",
  "map.shareNearMsg": "Deals near {place} right now on LytePress:",
  "promo.title": "\"We're on LytePress\" graphic",
  "promo.sub": "A square image with your QR code — post it to Instagram, Facebook or your WhatsApp status.",
  "promo.cta": "Download image",
  "promo.saved": "Image saved",
  "promo.savedNote": "Post it and anyone who scans lands straight on your deals.",
  "acc.weeklyRoundup": "Weekly round-up",
  "acc.dealsNearYouWeekly": "Deals near you, once a week",
  "acc.fiveClosestDeals": "The five closest live deals, emailed once a week. No more than that.",
  "acc.digestOn": "Weekly round-up on",
  "acc.digestOff": "Weekly round-up off",
  "acc.digestOnNote": "We'll email you the closest deals once a week.",
  "acc.digestOffNote": "No more weekly emails. Account emails still send.",
  "acc.tabDeals": "My deals",
  "acc.tabShop": "My shop",
  "acc.tabRedeem": "Redeem",
  "acc.tabAccount": "Account",
  "acc.postADeal": "Post a Deal",
  "acc.redeemACustomerS": "Redeem a customer's code",
  "acc.whenAShopperShows": "When a shopper shows their code or QR at checkout, scan it or type it here to confirm and apply their discount.",
  "acc.pointTheCameraAt": "Point the camera at the shopper's QR code.",
  "acc.dealsAlsoShowAn": "Deals also show an approximate price in this currency across the app.",
  "acc.recommendedLogo": "Recommended: logo",
  "acc.noCoverPhotoYet": "No cover photo yet",
  "acc.contactInfo": "Contact info",
  "acc.showContactInfoOn": "Show contact info on my public profile",
  "acc.addAnotherNumber": "Add another number",
  "acc.saveContactInfo": "Save contact info",
  "pc.yourPlan": "{plan} plan",
  "pc.freeForever": "Free, for as long as you like.",
  "pc.lifetime": "Yours for life — no renewal.",
  "pc.renews": "Renews {date}",
  "pc.autoRenewsOn": "Auto-renews on {date}",
  "pc.autoRenewOff": "Auto-renew off — plan ends {date}",
  "pc.cancelAutoRenew": "Cancel auto-renew",
  "pc.resumeAutoRenew": "Turn auto-renew back on",
  "pc.updateCard": "Update card",
  "pc.renewNow": "Renew now",
  "pc.graceMsg": "Renew now — your plan lapsed; benefits end in {n} days.",
  "pc.billingFail": "Couldn't open the billing portal. Please try again.",
  "pc.renewOffToast": "Auto-renew turned off — your plan runs until its end date",
  "pc.renewOnToast": "Auto-renew turned back on",
  "pc.renewFail": "Couldn't update auto-renew. Please try again.",
  "pc.buyDeals": "Buy extra deals",
  "bh.title": "Billing history",
  "bh.subtitle": "Every charge, with a receipt code you can quote us to verify a purchase.",
  "bh.loading": "Loading your receipts…",
  "bh.empty": "No payments yet.",
  "bh.invoice": "Invoice",
  "bh.paid": "paid",
  "bh.pending": "unfinished",
  "bh.refunded": "refunded",
  "pc.upgrade": "Upgrade",
  "pc.nOfMThisMonth": "{n} of {m} deals posted this month",
  "pc.unlimitedThisMonth": "Unlimited deals this month",
  "pc.nLeft": "{n} left",
  "pc.noneLeft": "None left this month",
  "pc.resets": "Your quota resets {date}",
  "pc.rolledOver": "Rolled over from last month",
  "pc.rollsOverNote": "Unused deals roll into next month, up to {cap}.",
  "pc.noRollover": "Free resets on the 1st — paid plans roll unused deals over.",
  "pc.boughtNote": "Bought. Never expire, even on Free.",
  "pc.giftedNote": "Gifted by us. Dated ones are spent first.",
  "pc.giftedHeld": "Gifted extras",
  "pc.giftedUseBy": "Use {n} before {date}",
  "lo.title": "A thank-you from LytePress",
  "lo.titleSoon": "Only {n} days left to use this",
  "lo.credits": "{n} extra deals are on your account already.",
  "lo.neverExpires": "They never expire.",
  "lo.useBy": "Use them before {date}.",
  "lo.codeLine": "And {off} off {what} with your code.",
  "lo.codeValid": "Yours alone, one use, until {date}.",
  "lo.useIt": "Use it",
  "lo.seePlans": "See plans",
  "lo.copy": "Copy code",
  "lo.pkgPro": "Pro monthly",
  "lo.pkgProYear": "Pro yearly",
  "lo.pkgElite": "Elite monthly",
  "lo.pkgEliteYear": "Elite yearly",
  "lo.pendingTitle": "A package picked for your shop",
  "lo.pendingWhat": "Unlocks {what}",
  "lo.pay": "Pay {price}",
  "lo.paying": "Opening checkout…",
  "lo.invoiceMonthly": "{price} — billed monthly, we'll invoice you.",
  "lo.payFailed": "Could not open checkout. Please try again.",
  "lo.pkgPlan": "your plan",
  "pc.maxDaysShort": "A deal may run up to {n} days",
  "pc.creditsHeld": "Extra deals held",
  "pc.nCreditsHeld": "{n} extra deals held",
  "pc.locations": "Locations pinned",
  "pc.nBought": "{n} bought",
  "pc.maxDays": "Days a deal may run",
  "pc.creditNote": "Extra deals are only used once your monthly quota runs out, and they never expire.",
  "tu.title": "Need more deals this month?",
  "tu.sub": "Extra deals never expire and are only used once your monthly quota runs out.",
  "tu.youHold": "You hold {n} right now.",
  "tu.each": "{price} each",
  "tu.perMonth": "/ 30 days",
  "tu.buy": "Buy",
  "tu.credits_5.label": "5 extra deals",
  "tu.credits_5.note": "Five extra deals on top of your monthly quota. They never expire.",
  "tu.credits_20.label": "20 extra deals",
  "tu.credits_20.note": "Twenty extra deals at 75c each instead of $1. They never expire.",
  "tu.credits_50.label": "50 extra deals",
  "tu.credits_50.note": "Fifty extra deals at 60c each — the cheapest way to post a lot. They never expire.",
  "tu.branch_1_30d.label": "1 extra location",
  "tu.branch_1_30d.note": "Pin one more location for 30 days. Buy it again to keep it.",
  "tu.branch_5_30d.label": "5 extra locations",
  "tu.branch_5_30d.note": "Pin five more locations for 30 days. Buy it again to keep them.",

  "tu.locationsTitle": "Extra map locations",
  "acc.upgradeForMore": "Upgrade for more",
  "acc.myDeals": "My Deals",
  "acc.featureNudgeTitle": "Be #1 in your category",
  "acc.featureNudgeBody": "Put one of your deals at the top of our homepage for your country's shoppers — just $10 for 24 hours.",
  "acc.featureNudgeCta": "Feature a deal",
  "acc.bookingsTitle": "Upcoming featured bookings",
  "acc.bookingCancel": "Cancel",
  "acc.bookingLive": "Live now",
  "acc.bookingCancelled": "Booking cancelled",
  "acc.bookingRefunded": "Cancelled — refunded to your card",
  "acc.bookingCancelFailed": "Couldn't cancel booking",
  "acc.youHavenTPosted": "You haven't posted any deals yet.",
  "acc.getListedTitle": "You're not listed yet",
  "acc.getListedBody": "New businesses only appear on LytePress once they publish a live deal. Post your first deal to get listed and start reaching shoppers near you.",
  "acc.postYourFirstDeal": "Post your first deal",
  "acc.pendingReview": "Pending review",
  "acc.undoGrabReleaseThis": "Undo grab — release this code",
  "acc.enterCodeEG": "Enter code e.g. 7K9M2Q",
  "acc.labelEGPort": "Label (e.g. Port of Spain branch)",
  "acc.removeNumber": "Remove number",
  "acc.shareOfViewersWho": "Share of viewers who claimed this deal",
  "acc.duplicateThisDealAnd": "Duplicate this deal and edit before relaunching",
  "acc.couldNotUpdatePreferences": "Could not update preferences",
  "acc.grabUndone": "Grab undone",
  "acc.couldnTUndo": "Couldn't undo",
  "acc.codeRedeemed": "Code redeemed ✓",
  "acc.couldnTRedeem": "Couldn't redeem",
  "acc.cameraUnavailable": "Camera unavailable",
  "acc.allowCameraAccessOr": "Allow camera access, or type the code instead.",
  "acc.saveMoreWasteLess": "Save More. Waste Less. — keep grabbing deals!",
  "acc.contactInfoSaved": "Contact info saved",
  "acc.couldNotSave": "Could not save",
  "acc.pleaseTryAgain": "Please try again.",
  "acc.uploadFailed": "Upload failed",
  "acc.dealRemoved": "Deal removed",
  "acc.couldNotRemove": "Could not remove",
  "acc.boostedForDays": "Boosted for 7 days",
  "acc.usedBoostPass": "Used a Boost Pass — {n} left.",
  "acc.couldNotUseYour": "Could not use your Boost Pass",
  "acc.couldNotStartCheckout": "Could not start checkout",
  "acc.frontPageForDays": "Featured for 7 days",
  "acc.copyCreated": "Copy created",
  "acc.couldNotDuplicate": "Could not duplicate",
  "tfa.twoFactorAuthentication": "Two-factor authentication",
  "tfa.addAnExtraLayer": "Add an extra layer of security using an authenticator app (Google Authenticator, Authy, 1Password).",
  "tfa.disableFa": "Disable 2FA",
  "tfa.trustedDevices": "Trusted devices",
  "tfa.revokeAllRequireFa": "Revoke all / require 2FA everywhere",
  "tfa.noTrustedDevicesWhen": "No trusted devices. When you log in, tick “Trust this device for 30 days” to skip the 2FA prompt here.",
  "tfa.eachCodeWorksOnce": "Each code works once if you lose your authenticator. Store them somewhere safe — they won't be shown again.",
  "tfa.copyAllCodes": "Copy all codes",
  "tfa.iVeSavedThem": "I've saved them",
  "tfa.confirmYourPasswordAnd": "Confirm your password and a current authenticator code to turn off 2FA.",
  "tfa.yourPassword": "Your password",
  "tfa.digitCode": "6-digit code",
  "tfa.deviceRevoked": "Device revoked",
  "tfa.thatDeviceWillNeed": "That device will need a 2FA code next time.",
  "tfa.couldNotRevokeDevice": "Could not revoke device",
  "tfa.allTrustedDevicesRemoved": "All trusted devices removed",
  "tfa.faWillBeRequired": "2FA will be required on every device.",
  "tfa.couldNotRevokeDevices": "Could not revoke devices",
  "tfa.couldNotStartFa": "Could not start 2FA setup",
  "tfa.pleaseTryAgain": "Please try again.",
  "tfa.twoFactorAuthenticationEnabled": "Two-factor authentication enabled ✓",
  "tfa.saveYourRecoveryCodes": "Save your recovery codes somewhere safe.",
  "tfa.couldnTVerifyCode": "Couldn't verify code",
  "tfa.twoFactorAuthenticationDisabled": "Two-factor authentication disabled",
  "tfa.youCanReEnable": "You can re-enable it anytime.",
  "tfa.couldNotDisableFa": "Could not disable 2FA",
  "trips.savedTrips": "Saved trips",
  "trips.saveADestinationAnd": "Save a destination and get deal alerts before you arrive.",
  "trips.addTrip": "Add trip",
  "trips.pickAPopularCity": "Pick a popular city…",
  "trips.departureOptional": "Departure (optional)",
  "trips.noTripsYetSave": "No trips yet — save one to get deal alerts before you land.",
  "trips.orSearchAnyCity": "…or search any city, hotel or landmark",
  "trips.searchPlace": "Search place",
  "trips.deleteTrip": "Delete trip",
  "trips.placeNotFound": "Place not found",
  "trips.tryACityHotel": "Try a city, hotel or landmark.",
  "trips.addADestinationAnd": "Add a destination and start date",
  "trips.tripSavedUUfe": "Trip saved \\u2708\\ufe0f",
  "trips.couldnTSaveTrip": "Couldn't save trip",
  "hrs.openingHours": "Opening hours",
  "hrs.setOnceHereEvery": "Set once here — every deal you post uses these hours to show shoppers when you're open.",
  "hrs.timeZone": "Time zone",
  "hrs.copyMondayToAll": "Copy Monday to all days",
  "hrs.holidayVacationMode": "Holiday / vacation mode",
  "hrs.showsYourBusinessAs": "Shows your business as “Temporarily closed” everywhere. Your deals stay visible.",
  "hrs.reopenDateOptional": "Reopen date (optional)",
  "hrs.messageOptional": "Message (optional)",
  "hrs.eGBackOn": "e.g. Back on Jan 5 — happy holidays!",
  "hrs.mondayCopiedToEvery": "Monday copied to every day",
  "hrs.tweakAnyDayThat": "Tweak any day that's different, then save.",
  "hrs.hoursSaved": "Hours saved",
  "hrs.yourOpeningHoursNow": "Your opening hours now apply to all your deals.",
  "hrs.couldNotSave": "Could not save",
  "hrs.pleaseTryAgain": "Please try again.",
  "br.businessLocations": "Business locations",
  "br.defaultCurrency": "Default currency",
  "br.yourDefaultCurrencyIs": "Your default currency is locked.",
  "br.itSFixedTo": "It's fixed to",
  "br.becauseYouAlreadyHave": "because you already have live deals — this keeps your pricing and past redemptions consistent. Contact support if you truly need to change it.",
  "br.usedAsTheDefault": "Used as the default price currency for new deals. Heads up: this locks once you post your first deal.",
  "br.weReMultinationalSet": "We're multinational — set a currency per branch",
  "br.pinEveryBranchLocation": "Pin every branch/location you operate. When you post a deal, these are used automatically as the deal's locations — you can still change them per deal.",
  "br.locationsSaved": "Locations saved",
  "br.newDealsWillDefault": "New deals will default to these locations and currency.",
  "br.couldNotSave": "Could not save",
  "br.pleaseTryAgain": "Please try again.",
  "tb.recentSearches": "Recent searches",
  "tb.didYouMean": "Did you mean",
  "tb.noQuickMatchesPress": "No quick matches — press Enter to search everything.",
  "tb.searchDeals": "Search deals",
  "tb.toggleAiAssistedSearch": "Toggle AI-assisted search",
  "tb.findDealsNearMe": "Find deals near me",
  "tb.removeFromRecentSearches": "Remove from recent searches",
  "tb.showDealsEverywhere": "Show deals everywhere",
  "tb.searchThisPlace": "Search this place",
  "tb.toggleTheme": "Toggle theme",
  "tb.locationSet": "Location set",
  "tb.placeNotFound": "Place not found",
  "tb.tryADifferentCity": "Try a different city, town or place name.",
  "tb.showingDealsEverywhere": "Showing deals everywhere",
  "tb.browsingDealsFromAll": "Browsing deals from all countries.",
  "tb.notSupported": "Not supported",
  "tb.geolocationIsnTAvailable": "Geolocation isn't available in this browser.",
  "tb.locationFound": "Location found",
  "tb.locationPermissionDenied": "Location permission denied",
  "tb.allowLocationForThis": "Allow location for this site in your browser's address-bar settings, then tap Near Me again.",
  "tb.locationTimedOut": "Location timed out",
  "tb.couldnTGetA": "Couldn't get a fix in time. Move to open sky or try again — or pick a city above.",
  "tb.locationUnavailable": "Location unavailable",
  "tb.weCouldnTDetermine": "We couldn't determine your position. Try again, or choose a country/city above.",
  "an.couldNotLoadAnalytics": "Could not load analytics.",
  "an.performanceOfYourDeals": "Performance of your deals and promotions.",
  "an.postADeal": "Post a Deal",
  "an.noDealsYetPost": "No deals yet — post your first deal to start seeing analytics.",
  "an.yourAverageDiscountIs": "Your average discount is",
  "an.belowTheNearbyAverage": "below the nearby average of",
  "an.forYourCategoryA": "for your category. A slightly bigger discount usually earns more views and shares.",
  "an.bestTimeToPost": "Best time to post",
  "an.lockedTitle": "Pro insights are locked",
  "an.lockedCta": "See what Pro adds",
  "an.newFollowersLastDays": "New followers (last 14 days)",
  "an.viewsOverTime": "Views over time",
  "an.lastDays": "Last 14 days",
  "an.noViewDataYet": "No view data yet — it will build up as shoppers open your deals.",
  "an.yourCompetition": "Your competition",
  "an.liveDeals": "Live deals",
  "an.avgDiscount": "Avg discount",
  "an.tipClickARival": "Tip: click a rival to compare your live deals side by side.",
  "an.redemptionsByDeal": "Redemptions by deal",
  "an.bestPerformer": "Best performer",
  "an.redemptionsAreCustomersWho": "Redemptions are customers who showed their LytePress code in-store — proof the platform sent them to you.",
  "an.redemptionsOverTime": "Redemptions over time",
  "an.dealLeaderboard": "Deal leaderboard",
  "an.byRedemptionRate": "by redemption rate",
  "an.viewsByCategory": "Views by category",
  "an.noDataYet": "No data yet.",
  "an.topPerformingDeals": "Top performing deals",
  "an.sharesOverTime": "Shares over time",
  "an.noSharesYetThis": "No shares yet — this line grows as shoppers share your deals with friends.",
  "an.mostSharedDeals": "Most-shared deals",
  "an.noSharesYetThis2": "No shares yet — this fills up as shoppers use the share button to spread your deals to friends.",
  "an.loadingComparison": "Loading comparison…",
  "an.noLiveDeals": "No live deals.",
  "an.matchOrBeat": "Match or beat",
  "an.totalViews": "Total views",
  "an.totalDeals": "Total deals",
  "an.activeDeals": "Active deals",
  "an.avgDiscount2": "Avg. discount",
  "an.totalShares": "Total shares",
  "an.inStoreRedemptions": "In-store redemptions",
  "an.nearExpiry": "Near expiry",
  "reg.registerYourBusiness": "Register your business",
  "reg.startPostingDealsTo": "Start posting deals to your community.",
  "reg.whereIsYourBusiness": "Where is your business?",
  "reg.yourMainLocationYou": "Your main location — you can add more branches after signup in My Account → Locations.",
  "reg.dealCurrency": "Deal currency",
  "reg.byCreatingAnAccount": "By creating an account you agree to our",
  "reg.termsOfUse": "Terms of Use",
  "reg.privacyPolicy": "Privacy Policy",
  "reg.alreadyRegistered": "Already registered?",
  "reg.logIn": "Log in",
  "reg.yourName": "Your name",
  "reg.businessName": "Business name",
  "reg.pickYourCity": "Pick your city",
  "reg.startTypingYourCity": "Start typing your city and choose it from the list.",
  "reg.accountCreated": "Account created!",
  "reg.registrationFailed": "Registration failed",
  "rst.setANewPassword": "Set a new password",
  "rst.chooseAStrongPassword": "Choose a strong password you don't use elsewhere.",
  "rst.thisResetLinkIs": "This reset link is invalid, already used or expired. Please request a new one from",
  "rst.forgotPassword": "Forgot password",
  "rst.minChars": "Use at least {n} characters for this account.",
  "rst.newPassword": "New password",
  "rst.confirmNewPassword": "Confirm new password",
  "rst.passwordTooShort": "Password too short",
  "rst.useAtLeastCharacters": "Use at least 8 characters.",
  "rst.passwordsDonTMatch": "Passwords don't match",
  "rst.passwordReset": "Password reset ✓",
  "rst.youCanNowLog": "You can now log in with your new password.",
  "rst.couldnTResetPassword": "Couldn't reset password",
  "fgt.checkYourEmail": "Check your email",
  "fgt.ifThatEmailIs": "If that email is registered, we've sent a link to reset your password. It expires in 45 minutes.",
  "fgt.forgotYourPassword": "Forgot your password?",
  "fgt.enterYourEmailAnd": "Enter your email and we'll send you a reset link.",
  "fgt.rememberedIt": "Remembered it?",
  "fgt.logIn": "Log in",
  "ct.contactUs": "Contact Us",
  "ct.questionsPartnershipsOrFeedback": "Questions, partnerships, or feedback — we’d love to hear from you.",
  "ct.sendMessage": "Send Message",
  "ct.yourName": "Your name",
  "ct.emailAddress": "Email address",
  "ct.yourMessage": "Your message",
  "ct.messageSent": "Message sent",
  "ct.thanksForReachingOut": "Thanks for reaching out — we usually reply within one working day.",
  "st.ourStory": "Our Story",
  "st.mission": "Our mission is simple: help people spend less on the things they already buy, help local shops fill quiet hours, and waste less food and stock along the way.",
  "st.saveMoreWasteLess": "Save More. Waste Less. Support Local.",
  "st.moreThanADirectory": "More than a directory. More than a deals website.",
  "st.lytepressIsAGrowing": "LytePress is a growing community that connects people with local businesses, rewards smart spending, supports entrepreneurship, and encourages sustainable consumption.",
  "st.asWeExpandThroughout": "As we grow across new cities and markets, our goal is to become the most trusted destination anywhere for discovering local offers, promotions, experiences, and opportunities.",
  "st.lookingAheadOurGoal": "Looking ahead, our goal is to expand into the international market — so that travellers and tourists can open LytePress anywhere in the world and instantly find the best deals near them, wherever their journey takes them.",
  "st.thinkOfItThis": "Think of it this way — sites like Expedia help you plan the trip; LytePress helps you save once you’re there, with the best local deals near you.",
  "st.whetherYouReA": "Whether you’re a business looking to reach new customers or a consumer looking to discover what’s happening around you, LytePress is here to help you save more, waste less, and support local.",
  "st.exploreDeals": "Explore Deals",
  "st.contactUs": "Contact Us",
  "st.supportLocal": "Support Local",
  "st.wasteLess": "Waste Less",
  "st.communityFirst": "Community First",
  "lg.lytepressOnlyEverCharges": "LytePress only ever charges",
  "lg.proSubscription": "plan (Pro or Elite)",
  "lg.onASingleDeal": "on a single deal, and a",
  "lg.placementShoppersUseLytepress": "placement, plus a small number of one-off add-ons (extra deal slots, a Boost Pass or priority verification). Shoppers use LytePress free of charge.",
  "lg.shoppersNeverPayUs": "Shoppers never pay us for a deal. Every offer is sold and redeemed by the business that posted it, so anything to do with the goods or service itself — the price charged in store, quality, availability, exchanges or refunds — is between the shopper and that business under their own policy and local consumer law.",
  "lg.ifABusinessRefuses": "If a business refuses to honour a deal it published, tell us using the report option on the deal or via the Contact page. We can remove the deal and the business from LytePress, but we cannot refund a purchase we did not take payment for.",
  "lg.ifYouReNot": "If you're not happy with a plan, ask us within",
  "lg.ofThePaymentAnd": "of the payment and we'll refund that payment in full. No reason needed, and it applies to both monthly and yearly plans.",
  "lg.afterDaysASubscription": "A plan is bought for a term (30 days or a year) and renews automatically. Your card is stored securely by our payment provider, Stripe — never by us — and charged at the start of each new term so your plan continues without a break. You can turn off auto-renew at any time from the Pricing page; you keep everything you paid for until the current term ends, and nothing is charged after that. If a renewal payment fails, your plan's benefits continue for a 3-day grace period while we retry, after which the account moves to Free. After 14 days a payment for a term already running is not refundable, and you keep everything you paid for until that term ends.",
  "lg.ifARenewalCharge": "A discount code applies only to the term it was used on: renewals are charged at the list price. You can see your renewal date and turn off auto-renew any time on the Pricing page. If a renewal ever takes you by surprise, contact us — where a paid term is unused we will normally refund it as a courtesy.",
  "lg.cancelAndWeRefund": "cancel and we refund in full.",
  "lg.thePlacementHasAlready": "the placement has already been delivered to shoppers, so it isn't refundable. You can still remove or edit the deal, but the spend stays used.",
  "lg.ifAPlacementFailed": "If a placement failed because of a fault on our side — it never went live, or the deal was hidden by us during the window — we refund it in full or re-run it, whichever you prefer.",
  "lg.emailUsFromThe": "Email us from the address on your LytePress account, or use the Contact page, with your business name and the date of the charge. We reply within 3 business days. Approved refunds go back to the original payment method, and can take 5–10 business days to appear depending on your bank.",
  "lg.refundsIncludeAnyTax": "Refunds include any tax we charged on the original payment. We refund in the currency you were billed in — if your bank converted the amount, the figure that lands may differ slightly because of exchange rates or bank fees we don't control.\n\nOur prices are set in US dollars (USD). At checkout our payment provider may display and charge the amount in your local currency, converted at its own exchange rate. Any transaction may also be subject to currency-conversion charges, bank fees, card-issuer fees or other charges applied by your bank or card provider. These are additional to the price shown, are outside our control, and are your responsibility.",
  "lg.pleaseTalkToUs": "Please talk to us before raising a dispute with your bank — we can almost always sort it faster. Accounts with an unresolved chargeback may have paid features paused until it's settled.",
  "lg.youCanStopUsing": "You can stop using LytePress whenever you like and delete your deals from My Account. Cancelling an account does not automatically refund a payment already taken — use the rules above.",
  "lg.billingQuestionsReachUs": "Billing questions? Reach us via the Contact page.",
  "lg.lytepressHelpsShoppersDiscover": "LytePress helps shoppers discover local and global deals and lets businesses publish offers. You must be able to form a binding contract to use the service, and you agree to use it lawfully.",
  "lg.youAreResponsibleFor": "You are responsible for keeping your login and any two-factor codes secure. Business accounts are responsible for the accuracy of the deals, prices, branches and contact details they publish.",
  "lg.dealsAreOfferedBy": "Deals are offered by the businesses that post them, not by LytePress. Availability, pricing and in-store redemption are the responsibility of that business. Redemption codes are for one-time use unless stated otherwise.",
  "lg.premiumSubscriptionsAndDeal": "Plans, Boosts, Featured placements and add-ons are billed through our payment processor. Boosts and Featured placements are never included in a plan — they are separate one-off purchases, and they are limited in number in each area, so a placement is only available while a slot near your shop is free. Elite deal and location allowances are fair-use ceilings, and \"priority placement\" means only that a Elite deal is shown first when two deals are the same distance from the shopper — it never puts a shop above one that is genuinely closer. Fees are shown before purchase. Taxes may apply based on your location. Refunds are covered by our",
  "lg.refundPolicy": "Refund Policy",
  "lg.setOutBelow": "set out in the billing sections below",
  "lg.termsOfUse": "Terms of Use",
  "lg.deletingYourAccount": "7. Deleting your account",
  "lg.deleteShopper": "Shoppers can delete their account at any time from My Account. This removes the account, saved codes, favourites and active sessions. Reviews you have written stay on the shop's profile, shown as “Deleted user”, because a shop's rating is other shoppers' information too.",
  "lg.deleteBusiness": "Businesses can only delete an account once it has no live or scheduled deals, and no paid term still running. This protects shoppers from finding map pins for a shop that no longer exists, and protects you from throwing away time you have already paid for: delete or let your deals expire, cancel renewal, and delete once the term ends. Write to us if you need to leave sooner.",
  "lg.deleteAdmin": "We may close an account ourselves — for example for repeated policy breaches or fraud — including one with live deals. We will email you the reason when we do.",
  "lg.privacyPolicy": "Privacy Policy",
  "lg.donTPostUnlawful": "Don't post unlawful, misleading or infringing content, attempt to disrupt the service, or misuse other users' data.",
  "lg.weMayUpdateThese": "We may update these terms or the service, and may suspend accounts that violate them. Continued use after changes means you accept the updated terms.",
  "lg.questionsAboutTheseTerms": "Questions about these terms? Reach us via the Contact page.",
  "lg.accountDetailsNameEmail": "Account details (name, email, role), business profile info (business name, category, location, contact numbers, logo/cover), and your preferences (display currency, followed businesses, location). If you enable two-factor authentication we store an encrypted secret and hashed recovery codes. If you add a passkey we store its public key and a signature counter. If you send feedback or a support message we keep the message, and your email only if you gave one, so we can reply.",
  "lg.toRunTheService": "To run the service — showing you relevant deals near you, sending deal notifications you opt into, processing redemptions and payments, and keeping your account secure.",
  "lg.ifYouUseNear": "If you use \"Near Me\" or Tourist Mode, we use the location you provide (or your device location, with permission) only to find nearby deals. You can always pick a location manually instead.",
  "lg.ipAndGeo": "To improve your experience, we use your IP address to estimate your approximate location (usually your country) so the map, deals and interface language default to where you are, rather than always starting elsewhere. This is an approximation and may be inaccurate; you can change your country, city and language at any time, and any such choice overrides the guess. Precise GPS location is only ever used if you tap \"Near Me\" and grant permission. IP-based location guesses are stored briefly, only to speed up return visits, and expire automatically.",
  "lg.analyticsTitle": "Analytics",
  "lg.analyticsBody": "We use privacy-friendly, third-party analytics software (for example Plausible Analytics) to understand how the site is used — such as which pages are visited and which features are popular. This may involve a third-party analytics provider processing anonymised, aggregated usage data on our behalf. These tools are cookieless and do not track you across other websites or build a personal profile of you. We may add, change or remove analytics providers over time.",
  "lg.notResponsibleForDeals": "LytePress is a listings platform only. Deals, prices, products, services and any redemption terms are created, offered and honoured entirely by the independent businesses that post them — they are not our offers. We do not sell, supply, endorse or guarantee any deal, and we are not responsible for the availability, accuracy, quality, safety or legality of what a business offers, or for a business refusing, changing or failing to honour a deal. Any purchase or redemption is a contract between you and that business; any dispute about a deal is between you and them. Please check each offer's details and the business's own terms before relying on it.",
  "lg.businessContactDetailsAre": "Business contact details are shown publicly only when the business chooses to make them public. A verified shop's public link (/s/shop-name) and its deal links show that shop's name, logo and live deals to anyone with the link — the shop can switch that link off at any time. We don't sell your personal data. We share limited data with our payment processor to complete purchases.",
  "lg.passwordsAreHashedFa": "Passwords are hashed, two-factor secrets are encrypted at rest, and sensitive actions are rate-limited. If you add a passkey we store only its public key and a counter — never your fingerprint, face or device PIN, which never leave your device. No system is perfectly secure, so please use a strong password and add a passkey or 2FA.",
  "lg.youCanEditYour": "You can edit your profile, hide your public contact info, manage trusted devices and passkeys, turn 2FA on or off, switch your public shop link off, and adjust notifications at any time from My Account. To have your account and personal data deleted, email support@lytepress.com and we will action it within 30 days.",
  "lg.privacyQuestionsReachUs": "Privacy questions? Reach us via the Contact page.",
  "lg.whatLytepressChargesFor": "1. What LytePress charges for",
  "lg.dealsAreNotSold": "2. Deals are not sold by LytePress",
  "lg.proSubscriptionsDayMoney": "3. Plans — how billing works and 14-day money back",
  "lg.boostsAndFeaturedPlacements": "4. Boosts and Featured placements",
  "lg.howToRequestA": "5. How to request a refund",
  "lg.taxesCurrencyAndFees": "6. Taxes, currency and fees",
  "lg.chargebacks": "7. Chargebacks",
  "lg.cancellingYourAccount": "8. Cancelling your account",
  "lg.contact": "9. Contact",
  "lg.usingLytepress": "1. Using LytePress",
  "lg.accounts": "2. Accounts",
  "lg.dealsRedemptions": "3. Deals & redemptions",
  "lg.payments": "4. Payments",
  "lg.acceptableUse": "5. Acceptable use",
  "lg.changesTermination": "6. Changes & termination",
  "lg.contact2": "8. Contact",
  "lg.whoWeAre": "1. Who we are",
  "lg.whoWeAreBody": "LytePress is the legal name of the entity that operates this platform, registered in Trinidad & Tobago, and is the data controller for the information described here. We serve businesses and shoppers worldwide, so your information may be processed in other countries by the providers listed under Sharing. Questions about your data: support@lytepress.com.",
  "lg.informationWeCollect": "2. Information we collect",
  "lg.howWeUseIt": "3. How we use it",
  "lg.location": "4. Location",
  "lg.sharing": "5. Sharing",
  "lg.security": "6. Security",
  "lg.yourChoices": "7. Your choices",
  "dd.savedTo": "Saved to",
  "dd.myDeals": "My Deals",
  "dd.save": "Save",
  "dd.saved": "Saved",
  "dd.favourite": "Save deal",
  "dd.backToDeals": "Back to deals",
  "dd.showThisAtCheckout": "Show this at checkout",
  "dd.changedYourMindUndo": "Changed your mind? Undo grab",
  "bp.businessNotFound": "Business not found.",
  "bp.browseBusinesses": "Browse businesses",
  "bp.loading": "Loading…",
  "bp.allBusinesses": "All businesses",
  "bp.noLiveDealsRight": "No live deals right now — follow to get notified when they post one.",
  "bp.verifiedBusiness": "Verified business",
  "bp.businessLocation": "Business location",
  "bl.localGlobalMerchants": "Local & global merchants",
  "bl.discoverBusinesses": "Discover businesses",
  "bl.followYourFavouriteShops": "Follow your favourite shops and never miss a fresh deal.",
  "bl.noBusinessesMatchThese": "No businesses match these filters.",
  "bl.viewProfile": "View Profile",
  "dsh.seePricesInYour": "See prices in your currency",
  "dsh.pickYourCurrencyAnd": "Pick your currency and every deal shows an instant estimate in the money you use.",
  "dsh.chooseCurrency": "Choose currency…",
  "psx.confirmingYourPayment": "Confirming your payment…",
  "psx.thisOnlyTakesA": "This only takes a moment.",
  "psx.paymentSuccessful": "Payment successful!",
  "psx.yourUpgradeIsNow": "Your upgrade is now active. Thanks for supporting LytePress.",
  "psx.goToMyAccount": "Go to My Account",
  "psx.backToPremium": "Back to Premium",
  "pcx.checkoutCancelled": "Checkout cancelled",
  "pcx.noWorriesYouHave": "No worries — you have not been charged.",
  "pcx.backToPremium": "Back to Premium",
  "nf.thisPageTookA": "This page took a detour",
  "nf.thePageYouRe": "The page you're looking for doesn't exist or may have expired. Let's get you back to the good stuff.",
  "nf.backHome": "Back home",
  "nf.browseDeals": "Browse deals",
  "nf.goBack": "Go back",
  "cat.exploreByCategory": "Explore by category",
  "cat.browseAll": "Browse all",
  "cat.grabThemFast": "Grab them fast",
  "md.undoGrab": "Undo grab",
  "bd.aiSearch": "AI Search",
  "bd.findingTheBestMatches": "Finding the best matches…",
  "bd.nearMe": "Near me",
  "bd.openNow": "open now",
  "bd.nearMe2": "near me",
  "bd.noExactMatchesSearching": "No exact matches — searching by meaning…",
  "lm.googleMapsApiKey": "Google Maps API key not configured.",
  "lm.loadingMap": "Loading map...",
  "pdx.movePhotoLeft": "Move photo left",
  "pdx.movePhotoRight": "Move photo right",
  "pdx.eGLyte": "e.g. LYTE20",
  "pdx.couldNotLoadDeal": "Could not load deal",
  "pdx.pleaseTryAgain": "Please try again.",
  "pdx.photosAdded": "Photos added",
  "ip.addLytepressToYour": "Add LytePress to your home screen",
  "ip.addToHomeScreen": "Add to Home Screen",
  "ip.fasterAccessToDeals": "Faster access to deals near you and your redemption codes — no app store needed.",
  "rev.verifiedReviews": "Verified reviews",
  "rev.verifiedRedemption": "Verified redemption",
  "rev.redeemOneOfThis": "Redeem one of this business's deals in-store to leave a verified review.",
  "rev.noReviewsYetBe": "No reviews yet — be the first after you redeem a deal.",
  "rev.shareHowTheDeal": "Share how the deal went (optional)…",
  "rev.replyPubliclyToThis": "Reply publicly to this review…",
  "rev.pickAStarRating": "Pick a star rating",
  "rev.tapStarsToRate": "Tap 1–5 stars to rate this business.",
  "rev.yourVerifiedReviewIs": "Your verified review is now live.",
  "rev.couldnTPostReview": "Couldn't post review",
  "rev.replyIsEmpty": "Reply is empty",
  "rev.writeAShortReply": "Write a short reply first.",
  "rev.replyPosted": "Reply posted",
  "rev.shoppersCanNowSee": "Shoppers can now see your response.",
  "rev.couldnTPostReply": "Couldn't post reply",
  "tm.sortingAround": "Sorting deals around {place}.",
  "tm.cancel": "Cancel",
  "tm.nearPlace": "near {place}",
  "tm.you": "you",
  "tm.changeBase": "change base",
  "tm.yourBases": "Your bases:",
  "tm.switchedTo": "Switched to {label}",
  "pw.placeholder": "Password",
  "pw.show": "Show password",
  "pw.hide": "Hide password",
  "pw.veryWeak": "Too weak",
  "pw.weak": "Weak",
  "pw.fair": "Getting there",
  "pw.strong": "Strong",
  "pw.veryStrong": "Very strong",
  "pw.needsWork": "Not strong enough yet",
  "pw.crackTime": "would take {time} to crack",
  "tm.touristMode": "Tourist Mode",
  "tm.localPrices": "Local prices",
  "tm.noneYet": "none yet",
  "tm.saveThisBase": "Save this base",
  "tm.iMVisitingShow": "I'm visiting — show the best deals near me",
  "tm.hotelLandmarkOrAddress": "Hotel, landmark or address…",
  "tm.setBaseLocation": "Set base location",
  "tm.exitTouristMode": "Exit tourist mode",
  "tm.removeBase": "Remove base",
  "tm.touristModeOn": "Tourist Mode on ✈️",
  "tm.showingDealsNearYou": "Showing deals near you, priced in your currency, with one-tap directions.",
  "tm.typeTheHotelLandmark": "Type the hotel, landmark or area you're staying at to see deals nearby.",
  "tm.baseUpdated": "Base updated 📍",
  "tm.placeNotFound": "Place not found",
  "tm.tryAHotelName": "Try a hotel name, landmark or address.",
  "rpt.reportThisDeal": "Report this deal",
  "rpt.tellUsWhatS": "Tell us what's wrong so our team can review it.",
  "rpt.reportDeal": "Report deal",
  "rpt.addAnyDetailsOptional": "Add any details (optional)",
  "rpt.spamOrMisleading": "Spam or misleading",
  "rpt.wrongOrFakePrice": "Wrong or fake price",
  "rpt.offensiveOrInappropriate": "Offensive or inappropriate",
  "rpt.expiredNoLongerAvailable": "Expired / no longer available",
  "rpt.somethingElse": "Something else",
  "rpt.signInToReport": "Sign in to report",
  "rpt.pleaseLogInTo": "Please log in to report a deal.",
  "rpt.thanksForTheReport": "Thanks for the report",
  "rpt.ourTeamWillReview": "Our team will review this deal.",
  "rpt.couldNotSubmitReport": "Could not submit report",
  "dlp.mapUnavailableNoApi": "Map unavailable (no API key)",
  "dlp.loadingMap": "Loading map…",
  "dlp.useBusinessDefaultCurrency": "Use business default currency",
  "dlp.openingHoursOverrideOptional": "Opening hours override (optional)",
  "dlp.placeNotFound": "Place not found",
  "dlp.tryADifferentAddress": "Try a different address or place name.",
  "dlp.gpsUnavailable": "GPS unavailable",
  "dlp.searchAnAddressInstead": "Search an address instead.",
  "dlp.pinnedYourLocation": "Pinned your location",
  "dlp.couldnTGetLocation": "Couldn't get location",
  "dlp.allowLocationAccessOr": "Allow location access or search an address.",
  "shb.shareDeal": "Share deal",
  "shb.shareThisDeal": "Share this deal",
  "shb.linkCopied": "Link copied",
  "shb.shareItWithFriends": "Share it with friends!",
  "shb.couldnTCopyLink": "Couldn't copy link",
  "shs.shareMySavings": "Share my savings",
  "shs.copied": "Copied!",
  "shs.pasteItAnywhereTo": "Paste it anywhere to invite friends.",
  "shs.couldnTCopy": "Couldn't copy",
  "shs.myLytepressSavings": "My LytePress savings",
  "rgc.monthlyRedemptionGoal": "Monthly redemption goal",
  "rgc.redemptionsMonth": "redemptions / month",
  "rgc.setAMonthlyTarget": "Set a monthly target to track your redemptions and keep the team motivated.",
  "rgc.goalReachedNicelyDone": "Goal reached — nicely done!",
  "obc.dismissChecklist": "Dismiss checklist",
  "obc.profileLinkCopied": "Profile link copied",
  "obc.pasteItOnWhatsapp": "Paste it on WhatsApp status, Instagram bio or your shop window.",
  "obc.hereSYourLink": "Here's your link",
  "obc.addYourLogo": "Add your logo",
  "obc.addAContactNumber": "Add a contact number",
  "obc.pinYourLocation": "Pin your location",
  "obc.postYourFirstDeal": "Post your first deal",
  "obc.shareYourProfileLink": "Share your profile link",
  "rr.alertsEnabled": "Alerts enabled",
  "rr.youLlBeNotified": "You'll be notified of new deals (demo).",
  "pc.popularDestinations": "Popular destinations",
  "sb.logOut": "Log out",
  "st.para1": "We believe discovering great local businesses should be easy, rewarding, and accessible to everyone.",
  "st.para2": "Every day, businesses launch new products, create special offers, host events, run promotions, and provide valuable services that many customers never hear about. At the same time, consumers are constantly searching for ways to save money, discover new experiences, and connect with their communities.",
  "st.para3": "We created LytePress to bring those two worlds together.",
  "st.para4": "LytePress is a platform where local businesses can showcase promotions, events, giveaways, special offers, and opportunities, while consumers can discover new ways to save, shop, dine, explore, and engage with the businesses around them.",
  "st.para5": "We’re also committed to reducing unnecessary waste by helping businesses promote surplus and near-expiry products that still have value, creating benefits for both businesses and consumers.",
  "st.valSupportLocal": "Connecting communities with the businesses around them.",
  "st.valWasteLess": "Promoting surplus and near-expiry products that still have value.",
  "st.valCommunity": "A growing community that rewards smart spending and entrepreneurship.",
  "st.sustainable": "Sustainable",
  "st.valSustainable": "Encouraging sustainable consumption in every market we serve.",
  "an.nViews": "{n} views",
  "an2.doNext": "Do this next",
  "an2.tipNearExpiry": "{n} deals expire within 48 hours — extend them or sharpen the price before they lapse",
  "an2.tipNearExpiryOne": "A deal expires within 48 hours — extend it or sharpen the price before it lapses",
  "an2.tipDiscount": "Your discounts run about {gap}% under nearby shops in your category — try {target}% on your next deal",
  "an2.tipBestTime": "Your shoppers look around {time} on {day} — post your next deal just before that",
  "an2.tipRedeem": "Only {rate}% of grabbed codes get used in store — a reminder or a deadline closes that gap",
  "an2.tipViewsDown": "Views are down {n}% on last week — a fresh deal lifts them faster than anything else",
  "an2.tipGrabRate": "Just {rate}% of viewers grab your deals — a sharper price or a clearer photo usually fixes that",
  "an2.tipShares": "Nobody has shared your deals yet — send your shop link to your own customers once and watch what it does",
  "an2.tipAllGood": "Nothing needs fixing today — your numbers are healthy. Post something fresh to keep them that way",
  "an2.proMore": "Pro works out the rest for you",
  "an2.grabs": "Codes grabbed",
  "an2.subVsLastWeek": "{n}% vs last week",
  "an2.subOfViews": "{n}% of viewers grab",
  "an2.subOfGrabs": "{n}% of those redeemed",
  "an2.subExpired": "{n} expired",
  "an2.trend": "Trend",
  "an2.mViews": "Views",
  "an2.mRedemptions": "Redemptions",
  "an2.mShares": "Shares",
  "an2.mFollowers": "Followers",
  "an2.noTrendData": "Nothing here yet for this one.",
  "an2.followersChip": "{n} followers",
  "an2.dealTable": "How each deal is doing",
  "an2.colDeal": "Deal",
  "an2.colViews": "Views",
  "an2.colGrabs": "Grabs",
  "an2.colRedeemed": "Redeemed",
  "an2.colRate": "Rate",
  "an2.colShares": "Shares",
  "an2.tableNote": "Rate is codes redeemed out of codes grabbed. A high rate means the offer genuinely converts — repeat it or boost it.",
  "an2.tableNoteFree": "Pro adds redemptions, redemption rate and shares for every deal in this table.",

  "an.nViewsNDeals": "{v} views · {d} deals",
  "an.nSharesNViews": "{s} shares · {v} views",
  "dc.seeAllIn": "See all {name} deals",
  "acc.nOfMLiveDeals": "{n} / {m} live deals",
  "cat.nLiveDeals": "{n} live deals",
  "cat.nCategories": "{n} categories",
  "bl.allCategories": "All categories",
  "reg.and": "and",
  "acc.planLabelPlan": "{plan} plan",
  "acc.showInCurrency": "Show in {code} — {label}",
  "home.slide1a": "Great Deals.",
  "home.slide1b": "Less Waste.",
  "home.slide1sub": "Discover deals from local businesses and rescue near-expiry items before they're gone.",
  "home.slide1badge": "Save up to 70%",
  "home.slide2a": "Shop Local.",
  "home.slide2b": "Save More.",
  "home.slide2sub": "Support local businesses and find the deals they're running near you.",
  "home.slide2badge": "Up to 60% off",
  "home.slide3a": "Every Deal.",
  "home.slide3b": "One Place.",
  "home.slide3sub": "Every category in one place, so you never miss a local deal.",
  "home.slide3badge": "Flash 50% off",
  "home.vp1t": "Save Money",
  "home.vp1x": "Great discounts on your favourite items",
  "home.vp2t": "Reduce Waste",
  "home.vp2x": "Help businesses reduce food and product waste",
  "home.vp3t": "Support Local",
  "home.vp3x": "Empower local businesses in your community",
  "home.slideN": "Slide {n}",
  "vf.title": "Business verification",
  "vf.unlocks": "Until you're verified you can run up to {deals} deals at a time and pin up to {pins} locations — paid placement stays closed. Verification lifts all three.",
  "vf.domainTier": "Domain email confirmed",
  "vf.domainTierNote": "You confirmed a code sent to {domain}, an address on your own business domain, so your trading limits are already lifted. Paid placement still waits on your documents.",
  "qa.liveCapTitle": "That's your live deal limit",
  "vf.body": "Send us your business documents and we'll add a blue verified badge to your profile. Shoppers trust verified shops more — and it unlocks every category.",
  "vf.riskyNote": "These categories need verification before you can post in them: {list}",
  "vf.upload": "Upload document",
  "vf.regPlaceholder": "Registration number (optional)",
  "vf.sent": "Documents sent",
  "vf.sentMsg": "We'll review them and email you — usually within a day.",
  "vf.failed": "Could not send that",
  "vf.pendingMsg": "We're reviewing your documents — we'll email you when it's done.",
  "vf.verifiedMsg": "Your business is verified. The blue badge shows on your profile and in the directory.",
  "vf.rejected": "We couldn't verify your business from those documents. Try clearer photos.",
  "vf.independent": "Independent seller",
  "vf.verifiedTag": "Verified business",
  "qa.needs_verification": "“{category}” deals can only be posted by a verified business. Get verified from My Account — usually within a day.",
  "bl.allCountries": "All countries",
  "bl.nDeals": "{n} deals",
  "sidebar.plusActive": "Elite active",
  "sidebar.forLife": "For life",
  "cat.Bakery": "Bakery",
  "cat.Electronics": "Electronics",
  "cat.Food & Beverages": "Food & Beverages",
  "cat.Groceries": "Groceries",
  "cat.Health & Beauty": "Health & Beauty",
  "cat.Restaurants": "Restaurants",
  "bl.nBusinesses": "{n} businesses",
  "cat.subScoped": "Browse hand-picked deals across every category in {scope}. Tap a tile to dive in.",
  "cat.subGlobal": "Browse hand-picked deals across every category from around the world. Tap a tile to dive in.",
  "cat.nLiveRightNow": "{n} live right now",
  "browse.verifiedOnly": "Verified only",
  "bl.verifiedOnly": "Verified only",
  "map.verifiedOnly": "Verified only",
  "browse.emptyVerified": "No verified businesses have live deals here yet — try turning off “Verified only”.",
  "trust.whatsThis": "What's this?",
  "trust.title": "What “verified” means",
  "trust.verifiedTitle": "Verified business",
  "trust.verifiedBody": "Approved by our team.",
  "trust.independentTitle": "Independent seller",
  "trust.independentBody": "Not approved yet — but plenty of great local sellers start here. Their deals are still checked for quality.",
  "trust.limitsTitle": "What it doesn't promise",
  "trust.limitsBody": "The badge is about who they are, not a guarantee of the product, the service or the price. Always check the deal terms before you buy.",
  "trust.reportTitle": "Something wrong?",
  "trust.reportBody": "Tap Report on any deal. Two reports flag it for our team, and we remove deals that mislead shoppers.",
  "trust.footer": "Sensitive categories — health, events, tech and automotive — can only be posted by verified businesses.",
  "apl.title": "Appeal a decision",
  "apl.subtitle": "Something we got wrong? Reply once and we'll settle it here.",
  "apl.appeal": "Appeal",
  "apl.send": "Send appeal",
  "apl.cancel": "Cancel",
  "apl.reason": "Our reason",
  "apl.placeholder": "Tell us what happened — the more specific, the faster we can fix it.",
  "apl.onceNote": "You can appeal each decision once. We reply by email.",
  "apl.sent": "Appeal sent",
  "apl.sentMsg": "We'll look at it and email you.",
  "apl.failed": "Could not send that",
  "apl.pending": "We're reviewing your appeal",
  "apl.granted": "Sorted — we agreed with you",
  "apl.declined": "We kept our decision",
  "apl.deal": "Deal removed: {title}",
  "apl.watch": "Your deals are reviewed before going live",
  "apl.watchDetail": "This happens after two deals were removed.",
  "apl.suspension": "Your account is suspended",
  "apl.verification": "Verification wasn't approved",
  "qa.appeal_short": "Please tell us what happened in at least 20 characters — it helps us settle this quickly.",
  "qa.appeal_once": "You've already appealed this once — we'll reply by email.",
  "acc.activeDeals": "Active deals",
  "acc.totalViews": "Total views",
  "acc.totalClaims": "Total claims",
  "acc.nClaims": "{n} claims",
  "acc.nConversion": "{n} conversion",
  "acc.goesLive": "Goes live {when}",
  "fn.title": "How shoppers move through your deals",
  "fn.subtitle": "Three real steps. No made-up conversion score.",
  "fn.views": "Views",
  "fn.grabs": "Grabs",
  "fn.redeemed": "Redeemed in store",
  "fn.viewsNote": "Times your deal pages were opened — counted once per shopper per day.",
  "fn.grabsNote": "Shoppers who tapped Grab, so the deal is saved in their pocket.",
  "fn.redeemedNote": "Codes you scanned in store — the only step that proves a real visit.",
  "fn.grabRate": "{n}% of views",
  "fn.redeemRate": "{n}% of grabs",
  "fn.honestTitle": "What these numbers can and can't tell you",
  "fn.honestBody": "We can only count deal pages opened, grabs, and codes you scan in store. We cannot see walk-ins who never grabbed a deal, what a customer spent, or whether they came back. Deals without a code have no redeemed step.",
  "fn.sourcesTitle": "Where your views came from",
  "fn.sourcesEmpty": "No view sources yet. Share a deal and check back.",
  "fn.sourcesNote": "Shares are links you or shoppers sent out. Direct means we couldn't tell where the visit started.",
  "fn.last30Days": "Last 30 days",
  "fn.nViewsPercent": "{n} views · {p}%",
  "fn.nGrabs": "{n} grabs",
  "fn.nRedeemed": "{n} redeemed",
  "fn.directionsTitle": "{n} people asked for directions",
  "fn.directionsNote": "Taps on Directions from the map or the deal page — the strongest sign someone set off to your shop.",
  "fn.nDirections": "{n} directions",
  "map.homeMapNote": "Map view is your home right now",
  "map.classicHome": "Classic home",
  "map.homeClassicNote": "Prefer the map as your home screen?",
  "map.openMap": "Use map home",
  "map.alertMe": "Alert me here",
  "map.alertSignIn": "Sign in free to get alerts for this area.",
  "map.alertSaved": "You'll get a ping for {area}",
  "map.alertSavedDesc": "{n} deals live here now, within about {km} km. Manage alerts under Following.",
  "map.alertFailed": "Couldn't save that area alert. Please try again.",
  "map.thisArea": "This area",
  "map.areasSection": "Area alerts ({n})",
  "map.areaRadius": "Within about {km} km",
  "map.areaRemoved": "Alerts off for {area}",
  "map.shareDialogTitle": "Share this map view",
  "map.sharePreview": "{n} deals in view — save up to {best}%",
  "map.sharePreviewNote": "That's roughly how the link will look when someone gets it.",
  "map.shareNoteLabel": "Add a note (optional)",
  "map.shareNotePlaceholder": "Lunch run — meet by the pastry place?",
  "map.shareNow": "Share link",
  "map.boostedPin": "Boosted",
  "map.shareCancel": "Cancel",
  "home.mapTitle": "Deals on the map",
  "home.mapSubtitle": "{n} deals pinned where you can actually walk in",
  "home.mapOpenFull": "Open full LyteMap",
  "home.mapNote": "Red pins end within 24 hours. Gold-rimmed pins are boosted by the shop.",
  "ct.subject": "Subject",
  "ct.sending": "Sending…",
  "ct.messageTooShort": "Please add a little more detail so we can help.",
  "ct.messageFailed": "We couldn't send that",
  "ct.tryAgainLater": "Please try again in a moment.",
  "ct.replyNote": "We read every message and usually reply within one working day.",
  "lg.lawDisputes": "7. Law & disputes",
  "lg.lawDisputesBody": "LytePress is the legal name of the entity that operates this platform and is registered in Trinidad & Tobago, while the service itself is available to businesses and shoppers worldwide — where we are registered is not a limit on where we operate. These terms are governed by the laws of Trinidad & Tobago, and its courts have jurisdiction over any dispute. This does not affect any rights you have under the consumer law of the country you live in, and it does not limit the countries LytePress serves. Talk to us first at support@lytepress.com — almost everything is sorted faster that way.",
  "lg.termsContact": "8. Contact",
  "lg.asIsTitle": "Service provided as is",
  "lg.asIsBody": "LytePress is an evolving platform, and while we strive to provide a reliable and seamless experience, occasional errors or downtime may occur. By using LytePress, you acknowledge that you do so at your own discretion and risk. We cannot guarantee uninterrupted service or accept responsibility for losses arising from the use of the platform. If you encounter any errors or issues, we kindly encourage you to notify us so we can work to resolve them as quickly as possible. We appreciate your understanding and support as we continue improving LytePress.",
  "lg.asIsShort": "LytePress is still growing and changing. It is provided as is — you use it at your own discretion and risk, and if something breaks, please tell us so we can fix it.",
  "lg.passwordRules": "Every password needs at least 8 characters, one capital letter and one symbol, and cannot contain your own name, shop name or email. Shop and admin accounts need 12 characters. We check new passwords against public lists of leaked passwords: a shop or admin account cannot use one that appears in a leak, and a shopper who chooses a weak or leaked password has to confirm they accept the risk.",
  "lg.quotaTerms": "Paid plans include a monthly number of deals you can post (a quota), not a guarantee of views, clicks or sales. Unused deals on a paid plan roll over for one month only, capped at one month's worth. Deals bought as add-ons do not expire. A quota is a fair-use ceiling and we may adjust the ceilings with notice.",
  "lg.aiHelp": "AI-assisted deal copy",
  "lg.aiHelpBody": "We offer an optional tool that drafts a deal title and description from the details and photo you provide. The draft is a suggestion only: you choose whether to use it, you can edit or undo it, and you remain responsible for everything published on your deal, including accuracy, claims and legal compliance. Your prompt and the first photo are sent to our AI provider to produce the draft. We limit how many drafts each shop can request per day and may switch the tool off at any time.",
  "lg.emailsWeSend": "Emails we send",
  "lg.emailsWeSendBody": "Account, security, payment and moderation emails are part of the service and always sent. Promotional email — new deal alerts, round-ups and offers — is capped at one email a day and three a week per account, and you choose how often you hear from us (as it happens, daily, weekly or not at all) plus quiet hours when nothing promotional is sent. Every promotional email carries an unsubscribe link, and we send in the language you use on the site where we have that wording.",
  "lg.quotasAndCredits": "5. Monthly quotas and extra deals",
  "lg.quotasAndCreditsBody": "A plan's monthly deal quota resets on the 1st. On paid plans unused deals roll over for one month only, capped at one month's worth, and they carry no cash value — an unused quota is not refundable and cannot be transferred between accounts. Extra deals or locations bought as add-ons are non-refundable once any part has been used; if none has been used, ask us within 14 days and we'll refund it.",
  "lg.collectLangEmail": "We also store the language you read the site in (so our emails match), your email frequency and quiet-hours settings, and a record of which promotional emails we have sent you so we can honour the daily and weekly caps.",
  "lg.sharingAi": "When you use the optional AI deal-writing tool, the text you entered and the first photo on the deal are sent to our AI provider to generate the draft. We do not send them your name, email or account details, and we do not use your deals to train anyone's models.",
  "lg.breachCheckPrivacy": "When you set a password we check it against public lists of leaked passwords using a method where only the first five characters of a one-way hash leave our server — your password, and the full hash, never do. If that service is unavailable we simply skip the check.",
  "lg.privacyEmailChoices": "You control promotional email from My Account: choose as it happens, daily, weekly or none, set quiet hours in your own timezone, or use the unsubscribe link in any promotional email. Account, security and payment emails cannot be switched off while your account is open.",
  "lg.plainSummary": "LytePress (\"we\", \"us\") lets businesses publish their offers and lets shoppers find the deals around them, wherever they trade. These pages are written in plain language on purpose, and if anything here is unclear you can email support@lytepress.com and a person will explain it. By using LytePress you agree to the points below.",
  "lg.boostsIntro": "A Boost buys attention for a fixed window, so timing matters.",
  "lg.boostStartsNowLabel": "It starts the moment you pay:",
  "lg.boostStartsNow": "a Boost goes live on your deal straight away and runs for the days you bought, so it can't be cancelled for a refund once purchased. If you buy one by mistake, contact us the same day and we'll sort it out.",
  "lg.refundTimeline": "Card payments are handled by our payment processor (Stripe) — we never see or store your card details. Approved refunds are sent back to the same card and usually appear within 5–10 business days, depending on your bank.",
  "bst.reportTitle": "What your boosts did",
  "bst.reportSub": "Each boost next to the same stretch of time just before it started.",
  "bst.running": "Running",
  "bst.finished": "Finished",
  "bst.directionsShort": "Directions",
  "bst.reportNote": "Boosted deals take turns at the top — the order rotates every hour so every boosted shop gets a fair share.",
  "bst.slotsLeft": "{n} of {limit} boost slots open for {category} in {city} right now",
  "bst.slotsFull": "All {limit} boost slots for {category} in {city} are running",
  "bst.slotsNote": "We cap live boosts to {limit} within {km}km of each shop, so a gold pin still stands out.",
  "bst.slotsLeftNear": "{n} of {limit} boost slots open for {category} within {km}km of your shop",
  "bst.slotsFullNear": "All {limit} boost slots for {category} within {km}km of your shop are running",
  "bst.nextFree": "The next slot opens {when} — a boost runs a full 7 days from the moment you buy it.",
  "bst.notifyMe": "Notify me when a slot opens",
  "bst.notifyQueued": "You're on the list — we'll email you the moment a {category} slot opens.",
  "bst.ownBoostLive": "\"{title}\" is already boosted in {category} — one live boost per category, so you never bid against yourself.",
  "adn.title": "Add-ons — pay only for what you need",
  "adn.sub": "Plans cover the features that cost us nothing to run. These are limited or take real work, so they're sold on their own — one-off, no subscription.",
  "adn.slotsTitle": "5 extra deal slots",
  "adn.slotsBody": "Five more live deal slots on top of your plan for 30 days. Buy again any time — they stack.",
  "adn.slotsCta": "Add 5 slots — {price}",
  "adn.slotsActive": "{n} extra slots active",
  "adn.boostTitle": "Boost a deal",
  "adn.boostBody": "Top of Browse, search, the map, Ending soon and the home deal rows for 7 days. Only 3 boosts run at once within 10km of your shop, so the badge keeps meaning something.",
  "adn.boostCta": "Boost from My Account",
  "adn.verifyTitle": "Priority verification",
  "adn.verifyBody": "Your registration documents jump to the front of our review queue instead of waiting their turn.",
  "adn.verifyCta": "Get priority review — {price}",
  "adn.verifyDone": "You have priority review — we'll get to your documents first.",
  "adn.verifiedAlready": "Your business is already verified.",
  "adn.oneOff": "One-off charges, not subscriptions",
  "srv.title": "Which would you pay for first?",
  "srv.sub": "Tap anything that applies. Your answers decide what we build and price next.",
  "srv.slots": "More deal slots",
  "srv.analytics": "Analytics & benchmarking",
  "srv.placement": "Top placement",
  "srv.verification": "Verified badge",
  "srv.followers": "Push to followers",
  "srv.saved": "Thanks — noted.",
  "bo.title": "Boost this deal",
  "bo.checking": "Checking what's free near you…",
  "bo.slotsLine": "{n} of {limit} sponsored spots free within {km}km of your shop",
  "bo.choose": "Choose",
  "bo.note": "A list never shows more than 3 sponsored deals, so sponsored shops take turns at the top each hour. Exclusive is the only option that can't be shared.",
  "bo.boostTitle": "Boost",
  "bo.boostBody": "One of 3 sponsored spots for 7 days, for shoppers within 10km.",
  "bo.reachTitle": "Boost + Reach",
  "bo.reachBody": "Same spot, but you also rank for shoppers up to 25km away — for shops people travel to.",
  "bo.exclTitle": "Exclusive",
  "bo.exclBody": "You take all 3 spots and rank out to 25km: yours is the only sponsored deal in your category nearby. Two weeks maximum, then the category opens up again.",
  "bo.exclBlocked": "Exclusive needs every spot free and {n} boost(s) are still running. Clear on {date}.",
  "br.limitNote": "{plan} covers {cap} pinned location(s). Pro pins 3 and Elite is unlimited.",
  "br.overLimit": "You have more locations saved than {plan} covers ({cap}). Everything already published stays on the map — upgrade to save changes here.",
  "acc.archived": "Archived",
  "acc.archivedWhy": "Taken down:",
  "acc.archivedNoReason": "No reason was given — ask us and we'll explain.",
  "acc.explainAppeal": "Explain what happened →",
  "sl.title": "Your shop link",
  "sl.sub": "One link for everything you've got on — {n} live right now. Paste it in WhatsApp and it shows your shop name, logo and how many deals are on.",
  "sl.shareMsg": "We've got {n} deals on right now — have a look:",
  "sl.copy": "Copy link",
  "sl.copied": "Link copied",
  "sl.on": "Link on",
  "sl.off": "Link off",
  "sl.switchedOn": "Your shop link is live",
  "sl.switchedOff": "Your shop link is off",
  "sl.offNote": "Your link is switched off, so it won't open for anyone. Switch it back on whenever you want to share again.",
  "sl.needVerified": "Shop links come with verification — it's what stops anyone else trading under your name. Send your documents in and yours switches on automatically, built from your business name.",
  "sl.getVerified": "Get verified",
  "sl.dealLinks": "Every deal gets its own link too — here's “{title}”:",
  "sl.copiedNote": "Paste it anywhere — it opens straight on your shop page.",
  "sl.customTitle": "Choose your own link",
  "sl.customPlus": "Included with Elite — pick the words after /s/ yourself.",
  "sl.customOwned": "You own this add-on — change the words after /s/ whenever you like.",
  "sl.customOffer": "Your link is built from your business name. Want different words after /s/? It's {price} once, yours for good — or free on Elite.",
  "sl.customBuy": "Name my link — {price}",
  "sl.customEdit": "Edit my link",
  "sl.customSave": "Save link",
  "sl.customCancel": "Cancel",
  "sl.customPlaceholder": "your-shop-name",
  "sl.customSaved": "Your new link is live",
  "adn.linkTitle": "Choose your own shop link",
  "adn.linkBody": "Pick the words after /s/ yourself instead of using your business name — shorter to say out loud, easier to paste. Yours for good, one payment.",
  "adn.linkCta": "Name my link — {price}",
  "adn.linkIncluded": "Included with Elite",
  "adn.linkSetIt": "Set my link",
  "adn.linkNeedsVerify": "Shop links come with verification — send your documents in first.",
  "pc.placeholder": "Discount code",
  "pc.apply": "Apply",
  "auth.or": "or",
  "fb.button": "Feedback",
  "fb.title": "Tell us what you think",
  "fb.sub": "Anything broken, missing or brilliant — it comes straight to us. No account needed.",
  "fb.typeBug": "Something's broken",
  "fb.typeIdea": "I've got an idea",
  "fb.typeCompliment": "Something I love",
  "fb.typeOther": "Something else",
  "fb.messagePlaceholder": "Tell us what happened, or what you'd like to see…",
  "fb.emailLabel": "Email (optional — only so we can reply)",
  "fb.context": "Send the page and device I'm on",
  "fb.contextOn": "Helps us reproduce it: {path}, plus screen size, language and browser. No cookies or personal data.",
  "fb.contextOff": "We'll only get your message.",
  "fb.send": "Send it",
  "fb.sent": "Thank you — that's with us",
  "fb.sentNote": "A person reads every one of these. We'll reply if you left an email.",
  "fb.failed": "Couldn't send that",
  "fb.tooShort": "A few more words and we'll know what to fix",
  "pn.title": "Lock your shop to this device",
  "pn.body": "Your deals are live. Add a passkey and only your face, fingerprint or device PIN can get into this shop — no password to guess or steal.",
  "pn.add": "Add a passkey",
  "pn.notNow": "Not now",
  "pk.title": "Passkeys",
  "pk.sub": "Sign in with Face ID, your fingerprint or your device PIN. Your password keeps working as a backup.",
  "pk.add": "Add a passkey",
  "pk.added": "Passkey added",
  "pk.addedNote": "Next time, tap \"Sign in with a passkey\" — no password to type.",
  "pk.removed": "Passkey removed",
  "pk.remove": "Remove",
  "pk.none": "No passkeys yet. Add one and this device can sign you in without a password.",
  "pk.unsupported": "This browser doesn't support passkeys yet — your password and 2FA still work as normal.",
  "pk.cancelled": "Cancelled",
  "pk.failed": "That didn't work",
  "pk.lastUsed": "Last used {date}",
  "pk.never": "Not used yet",
  "pk.signIn": "Sign in with a passkey",
  "pk.loginFailed": "Couldn't sign you in",
  "pk.loginFailedNote": "Try your password, or add a passkey from My Account first.",
  "cq.need": "Need more room?",
  "cq.title": "Ask for higher limits",
  "cq.sub": "Elite covers {deals} live deals and {branches} locations as fair use. Tell us what your chain actually needs and we'll set it.",
  "cq.deals": "Live deals you need",
  "cq.branches": "Locations you need",
  "cq.notePlaceholder": "Anything we should know — how many branches you run, what you're planning…",
  "cq.send": "Send request",
  "cq.sentTitle": "Request sent",
  "cq.sentNote": "We'll look at it and email you — usually within a day.",
  "cq.pending": "Higher limits requested — we'll email you",
  "cq.failed": "Couldn't send that",
  "pc.remove": "Remove code",
  "pc.invalid": "That code isn't valid.",
  "pc.appliedPct": "{code} — {n}% off",
  "pc.appliedAmt": "{code} — ${n} off",
  "pc.haveCode": "Have a discount code?",
  "bst.kindFeatured": "Featured on the home page, {km}km",
  "bo.extendLocked": "You're running {kind} — add days to that one so you don't lose it. You can switch once the run ends.",
  "bo.close": "Close",
  "bo.extendSame": "Adds {n} more days to what you're running now.",
  "bo.extendToReach": "Adds {n} days and widens your reach from 10km to 25km for the whole run.",
  "bo.extendToExclusive": "Adds {n} days and takes all 3 sponsored spots, out to 25km.",
  "bo.extendNarrower": "Adds days, but narrows your reach back to 10km.",
  "sr.title": "Sponsored slots near you",
  "sr.sub": "Only {limit} sponsored spots run at a time in each category within {km}km of your shop. Here's what's free right now.",
  "sr.loading": "Checking the slots around your shop…",
  "sr.open": "{n} of {limit} free within {km}km",
  "sr.full": "All {limit} running right now",
  "sr.fullNext": "All {limit} running — the next opens {date}",
  "sr.exclusiveHeld": "A shop holds Exclusive here until {date}",
  "sr.watch": "Watch",
  "sr.watchAnother": "Watch another category:",
  "sr.pickCategory": "Pick a category",
  "sr.watching": "Watching",
  "sr.watchOn": "We'll ping you the moment a {category} slot opens",
  "sr.watchOff": "Stopped watching {category}",
  "sr.passNeedsVerification": "Boost Passes open up once your business is verified.",
  "sr.buyPass": "Buy a Boost Pass — {price}",
  "sr.passesHeld": "{n} Boost Pass ready to use",
  "sr.note": "A Boost Pass is a boost paid for in advance at the normal price — hold it until a slot opens, then use it in one tap. It never expires and it doesn't jump the queue, so the cap stays fair.",
  "fp.title": "Here's your Featured spot",
  "fp.honest": "This is the one Featured spot for your category — the only featured deal shoppers see there, worldwide.",
  "fp.note": "Featured is the front-page row — one spot per category. Choose your country (seen by local shoppers) or worldwide (seen everywhere). Runs 24 hours; buying again while it's live adds another day on the end.",
  "fp.reachLocal": "My country",
  "fp.reachLocalNote": "Top of your category for shoppers here",
  "fp.reachGlobal": "Worldwide",
  "fp.reachGlobalNote": "Top of your category everywhere",
  "fp.today": "Today (start now)",
  "fp.pickDay": "Start today, or pre-book a day",
  "fp.slots": "The Featured spot for your category is open — claim it for 24 hours.",
  "fp.full": "The Featured spot for your category is taken right now — the next opens {date}. There's one spot per category.",
  "fp.notNow": "Not now",
  "fp.buy": "Feature it — {price}",
  "bo.excl14Title": "Exclusive · 2 weeks",
  "bo.excl14Body": "The same lock-out, paid upfront for the full fortnight and cheaper than two single weeks. After it, the category reopens for everyone.",
  "bo.extendTitle": "Extend this boost",
  "bo.extendLine": "Running until {date} — extra days are added on the end, you lose nothing.",
  "bo.addDays": "Add {n} days",
  "bo.extendNote": "Extra days start when your current run ends, so your deal never drops out of the sponsored spots mid-week.",
  "bo.exclRunway": "You've held Exclusive for {held} of {max} days in a row. The category reopens for everyone until {date}.",
  "adn.featTitle": "Featured on the home page",
  "adn.featBody": "Your deal takes the single Featured spot for its category on the home page for 24 hours — the only featured deal in that category, shown to shoppers everywhere. Boost lifts you in Browse, the map and search; Featured puts you on the front page.",
  "adn.featCta": "Feature from My Account",
  "card.sponsored": "Sponsored",
  "lg.listingDiscretion": "Keeping LytePress worth opening means we review what gets published. We may edit, archive or remove any listing, and withdraw access to the service, where we judge it necessary — for example content that looks inaccurate, unsafe, duplicated or out of place. We'll normally tell the business why, though we don't have to ask first.",
  "lg.listingModerationRecords": "Content you publish — deals, photos and business details — is reviewed as part of running the service, and a copy of a listing we take down may stay in our internal records for a period so we can handle appeals, disputes and repeat issues.",
  "bst.kindReach": "Reach {km}km",
  "bst.kindExclusive": "Exclusive",
  "bst.shareCrowded": "{n} other boosts overlapped your area, so you held a top spot roughly {pct}% of the time. Exclusive would have made it all of it.",
  "bst.shareClear": "You had a top spot the whole time — nothing else was competing nearby.",
  "tfa.enable2fa": "Enable 2FA",
  "pv.verifiedOn": "Price verified {date}",
  "pv.checkFirst": "Check price before you go",
  "pv.changed": "Shoppers say this price changed",
  "pv.tooltip": "The last time someone stood behind this price.",
  "pv.countOne": "1 shopper has confirmed it",
  "pv.countMany": "{n} shoppers have confirmed it",
  "pv.shopperHelp": "Been in recently? Tell everyone else whether this price still holds.",
  "pv.ownerHelp": "Still your price? One tap re-stamps this deal as verified today.",
  "pv.signInHint": "Sign in as a shopper to confirm this price.",
  "pv.stillRight": "Price is still right",
  "pv.priceChanged": "Price changed",
  "pv.youConfirmed": "You confirmed this price.",
  "pv.youFlagged": "You told us this price changed.",
  "pv.thanksConfirmed": "Thanks — price verified",
  "pv.thanksConfirmedMsg": "Every shopper who sees this deal now knows the price is current.",
  "pv.thanksFlagged": "Thanks for the heads-up",
  "pv.thanksFlaggedMsg": "We'll ask the shop to re-state the price.",
  "pv.couldNotSave": "Could not save that",
  "pv.wasItRight": "Was the price right?",
  "pv.yesRight": "Yes, spot on",
  "pv.noChanged": "No, it changed",
  "footer.cities": "Cities",
  "cities.seoTitle": "Deals by city",
  "cities.seoDesc": "Every city with live deals on LytePress, plus the places we're opening next.",
  "cities.heading": "Deals by city",
  "cities.subline": "Pick your town and see what's on right now. New cities appear here as soon as shops start posting.",
  "cities.openingSoon": "Opening soon",
  "city.seoTitle": "Deals in {city}, {country}",
  "city.seoDesc": "{deals} from {shops} in {city}, {country}. Prices confirmed by shoppers, updated every day.",
  "city.seoDescEmpty": "LytePress is opening in {city}, {country}. Know a shop that should be here? Invite them.",
  "city.heading": "Deals in {city}",
  "city.subline": "{deals} from {shops} across {city}, {country} — with prices shoppers have confirmed.",
  "city.sublineEmpty": "We're opening in {city}, {country}. No deals here just yet.",
  "city.liveDeals": "{n} live deals",
  "city.liveDealOne": "1 live deal",
  "city.shops": "{n} shops",
  "city.shopOne": "1 shop",
  "city.onTheMap": "See them on the map",
  "city.allCities": "All cities",
  "city.noPage": "No deals page for that city yet.",
  "city.emptyTitle": "Nothing live in {city} yet",
  "city.emptyBody": "We open a city the moment a shop posts there. If you know somewhere in {city} worth a spot on the map, send them our way — it takes a minute and it's free.",
  "city.browseEverywhere": "Browse deals everywhere",
  "city.aboutTitle": "About deals in {city}",
  "city.aboutBody": "LytePress lists what local shops in {city}, {country} have marked down right now — mostly {cats}. Every deal shows the price, what it was, how long it runs and exactly where to go.",
  "city.aboutTrust": "Prices carry the date they were last confirmed, and shoppers who have been in can tell everyone else whether a price still holds. Nothing here is a guess.",
  "city.everyCategory": "every category",
  "city.nearbyTitle": "Other cities",
  "city.otherLanguages": "Read this in",
  "loc.following": "Following your location",
  "loc.followingLive": "Following you as you move",
  "loc.notFollowing": "Location pinned here",
  "loc.turnOff": "turn off",
  "loc.turnOn": "follow me again",
  "loc.goLive": "follow as I move",
  "loc.stopLive": "stop following live",
  "loc.nearCity": "You're near {city}",
  "loc.seeThoseDeals": "See those deals",
  "pd.quietHours": "Quiet hours deal",
  "pd.quietHoursHint": "A standing discount that repeats — like 3pm to 5pm on weekdays, to fill the lull.",
  "pd.quietFrom": "From",
  "pd.quietTo": "Until",
  "pd.quietNote": "Shoppers still see the deal outside these hours — it shows when it opens, and codes only work inside the window.",
  "pd.mon": "Mon",
  "pd.tue": "Tue",
  "pd.wed": "Wed",
  "pd.thu": "Thu",
  "pd.fri": "Fri",
  "pd.sat": "Sat",
  "pd.sun": "Sun",
  "time.am": "am",
  "time.pm": "pm",
  "qh.onUntil": "On until {time}",
  "qh.starts": "Starts {time}",
  "qh.runs": "Runs {days}, {from} to {to}",
  "qh.weekdays": "weekdays",
  "qh.weekends": "weekends",
  "qh.everyDay": "every day",
  "pitch.print": "Print both sheets",
  "pitch.printHint": "Two pages: this city, then what LytePress is. Print or save as PDF.",
  "pitch.cityHeading": "{city} is already on the map.",
  "pitch.citySub": "This is what shoppers in {city}, {country} see when they open LytePress and look for something worth leaving the house for.",
  "pitch.statDeals": "Live deals",
  "pitch.statShops": "Shops listed",
  "pitch.statTop": "Most listed",
  "pitch.cityHeadingDemo": "{city} is next on the map.",
  "pitch.citySubDemo": "LytePress is opening in {city}, {country}. This is what shoppers here will see — and what your own listing would look like on it.",
  "pitch.sellFreeN": "Free",
  "pitch.sellFree": "To list your deals",
  "pitch.sellFastN": "2 min",
  "pitch.sellFast": "To sign your shop up",
  "pitch.sellLiveN": "Today",
  "pitch.sellLive": "Your first deal goes live",
  "pitch.mapTitle": "The map today",
  "pitch.yourSpot": "Your spot",
  "pitch.noMapKey": "Map unavailable",
  "pitch.alreadyOn": "Already on LytePress here",
  "pitch.exampleTitle": "What a week in {city} looks like",
  "pitch.exampleTag": "Example",
  "pitch.demoNote": "The pins and listings above are examples — {city} is open and waiting for its first shops.",
  "pitch.mapCaptionDemo": "Example pins — this is how a town looks once shops start posting.",
  "pitch.claimTitle": "There's a gap in {city}.",
  "pitch.claimBody": "Scan to claim your spot. Listing is free, it takes about two minutes, and your first deal can be live today.",
  "pitch.qrCityPage": "See {city} deals",
  "pitch.qrClaim": "Claim your spot",
  "pitch.aboutHeading": "What LytePress is.",
  "pitch.aboutLine": "A map of real deals from real shops. Shoppers open it to see what's marked down near them right now — and every price carries the date someone last stood behind it.",
  "pitch.mapCaption": "Each pin is a shop with a live deal.",
  "pitch.forShoppers": "For shoppers",
  "pitch.shopper1": "See what's discounted within walking distance, right now, with walking directions to the door.",
  "pitch.shopper2": "Every price shows when it was last confirmed — by the shop, or by a shopper who was just there.",
  "pitch.shopper3": "Near-expiry food and short-dated stock in one place, so good food gets eaten instead of binned.",
  "pitch.forShops": "For shops",
  "pitch.shop1": "Listing is free. You post a deal, it appears on the map and on your town's page.",
  "pitch.shop2": "Move stock that's close to date instead of writing it off.",
  "pitch.shop3": "Fill your quiet hours with a standing discount that runs only in the window you choose.",
  "pitch.howTitle": "How it works",
  "pitch.how1": "Sign up as a shop and drop a pin where you actually are.",
  "pitch.how2": "Post your deal — a photo, the price, and how long it runs.",
  "pitch.how3": "Shoppers nearby see it, walk in, and show a code you verify at the counter.",
  "pitch.startTitle": "Start with one deal.",
  "pitch.startBody": "Scan this, sign up, and put one offer on the map. If nobody comes, you've lost two minutes.",
  "pitch.qrStart": "Sign your shop up",
  "browse.nothingWithin": "Nothing within {radius} right now",
  "browse.nothingWithinMsg": "No live deal has a pin inside {radius} of you. Rather than fill this page with shops you can't reach, here's the honest answer — and two ways to widen the search.",
  "browse.showFurther": "Show {n} deals further afield",
  "browse.hideFurther": "Hide deals further afield",
  "browse.furtherNote": "These are outside {radius} of you, nearest first.",
  "browse.browseCountry": "Browse the whole country",
  "mt.title": "We'll be right back",
  "mt.body": "LytePress is having a scheduled update. Nothing on your account is affected — deals, credits and codes are all exactly where you left them.",
  "mt.backIn": "Back online in",
  "mt.backAt": "Expected back at {time}",
  "mt.soon": "Back online any moment now.",
  "mt.staff": "Staff sign in",
  "mt.readonly": "Scheduled maintenance: you can browse, but posting and payments are paused.",
  "mt.notice": "Scheduled maintenance {when} — the site may be briefly unavailable.",
  "mt.adminOn": "Maintenance mode is ON — everyone but admins is locked out.",
  "prc.usdNote": "Billed in US dollars. If your card is in another currency, your bank converts at its own rate, so your statement may show a slightly different amount.",
  "prc.feeNote": "Your bank may add currency-conversion or transaction fees.",
  "lg.availabilityTitle": "Service availability & scheduled maintenance",
  "lg.availabilityBody": "LytePress is updated regularly. Software updates and maintenance are carried out at intervals, and access to the site, the app or your dashboard may be temporarily unavailable while that work is done.\n\nWhere the work is planned and likely to interrupt the service, we aim to show notice in the app beforehand and to schedule it for quiet hours. Short periods of planned or unplanned downtime are a normal part of running an online service and do not by themselves entitle you to a refund. If a paid Boost or Featured placement did not run because of an outage on our side, we credit or refund that placement — email support@lytepress.com and we will put it right.",
  "lg.forceMajeureTitle": "Force majeure",
  "lg.forceMajeureBody": "Neither you nor LytePress is responsible for failing to meet an obligation under these terms when the cause is outside reasonable control. That includes storms, hurricanes, flooding, earthquakes, fire, epidemic or pandemic, war, civil unrest, strikes, acts or orders of a government or regulator, failure of electricity or internet service, and the failure or suspension of a third-party provider we rely on such as our hosting, payment, mapping or email providers.\n\nWhile such an event lasts, the affected obligations are paused rather than broken, and we will restore normal service as soon as it is reasonably possible. If an event of this kind keeps the service down for more than 30 days in a row, either of us may end a paid subscription and we will refund the unused part of the term.",
};

export default en;
